import {
  Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy,
  ViewChild, HostListener, Injectable, OnChanges
} from '@angular/core';
// import {startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours} from 'date-fns';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import {
  I18n, CustomDatepickerI18n, NgbDateCustomParserFormatter,
  NgbDateNativeAdapter
} from '../../../commons/input-date/injection-datepicker';

import { CommonService } from '../../../commons/services/common.service';

import { AlertService } from '../../../commons/services/alert.service';
import { throwMatDuplicatedDrawerError } from '@angular/material/sidenav';
import { GestionSygetrack } from '../../../recylog/application/gestion.sygetrack';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-create-prestation',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './create-prestation.component.html',
  styleUrls: ['./create-prestation.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }]
})
export class CreatePrestationComponent implements OnInit, OnChanges {
  @Input() planning;
  @Input() eventSelected;
  @Input() selectedEvent;
  @Input() isEdit: Boolean;
  @Input() isHistoLoc: Boolean;
  @Input() is_recreate: Boolean;
  @Input() moduleSource = "ecoloc";
  @Input() isDepuisDonneesTechniqueContrat: Boolean;

  @Output() closefct = new EventEmitter<any>();
  @Output() reinitfct = new EventEmitter<any>();
  @Output() rafraichir = new EventEmitter<any>();
  @Output() loading = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() updateFct = new EventEmitter<any>();

  @ViewChild('calendar') calendar;
  @ViewChild('popover') popover;
  @ViewChild('template') template;
  @ViewChild('format') format;
  @ViewChild('msg') msg;
  @ViewChild('popTemplate') popTemplate;
  @ViewChild('programConfirme') programConfirme;
  @ViewChild('confirmeImpBonSansLeader') confirmeImpBonSansLeader;
  @ViewChild('changedate') changedate;
  @ViewChild('templateSupressionFille') templateSupressionFille;
  @ViewChild('champInvalid') champInvalid;
  @ViewChild('confirmePrestPostprogramme') confirmePrestPostprogramme;
  
  term$ = new Subject<string>();
  events: any[] = [];
  showpopover: Boolean = false;
  modifier: Boolean = false;
  status: { isopen: Boolean, isopens: Boolean } = { isopen: false, isopens: false };
  showSpinner: Boolean = false;
  dataClient: any[] = [];
  dataArticle: any[] = [];
  dataExutoire: any[] = [];
  dataCamion: any[] = [];
  dataChauffeur: any[] = [];
  selected: any = {};
  searchSelected: any = {};
  resultSearch = [];
  listeFiltre = [];
  eventToDrop: any = {};
  formatPerso = [];
  first: Boolean = false;
  width = 279;

  isToogle: Boolean = false;
  isChecked: Boolean = true;
  isHisto: Boolean = false;
  showBtnvalid: Boolean = false;
  affichageMoyenhumain: Boolean = true;
  showAlert: Boolean = false;
  rappelLibre: Boolean = false;
  showFicheclt: Boolean = false;
  showHistorique: Boolean = false;
  addChantier: Boolean = false;
  showFichechantier: any = false;
  isEditChantier: Boolean = false;
  addClient: Boolean = false;
  param: any = {};
  user: any = {};
  idSitePrestEdit;
  header: any;
  height = 460;
  typeCalendar: String = '';
  formatprs: String = '';
  motifAnnulationFille = '';

  event;

  dialogVisible: Boolean = false;
  eventsNotassign: any[] = [];

  id = 100;
  locale = 'FR';
  resources: any[] = [];
  optionConfig = {};
  buttonText = {
    today: 'Aujourd\'hui',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
  };

  bonCreated: String = '';
  placeholder: String = '';
  searchElem: String = '';
  plhd_heurStart: String = 'HH';
  plhd_heurEnd: String = 'HH';
  plhd_minStart: String = 'MM';
  plhd_minEnd: String = 'MM';
  validHeur: Boolean = false;
  step = 1;
  keyword: String;
  week: number;
  month: String = '';
  curentDate;
  error = '';
  raisonReport: String = '';


  isClickAdd: Boolean = false;
  updateAll: Boolean = false;

  isDIS: Boolean = false;

  protected rappel = [
    { id: '0', libelleObjetEntite: 'Aucun' },
    { id: '1', libelleObjetEntite: '5 minutes' },
    { id: '2', libelleObjetEntite: '15 minutes' },
    { id: '3', libelleObjetEntite: '30 minutes' },
    { id: '4', libelleObjetEntite: '1 heures' },
    { id: '5', libelleObjetEntite: '2 heures' },
    { id: '6', libelleObjetEntite: '1 jours' },
    { id: '7', libelleObjetEntite: '2 jours' },
  ];

  protected typerappel = [
    { id: '0', libelleObjetEntite: 'Minutes' },
    { id: '1', libelleObjetEntite: 'Heures' },
    { id: '2', libelleObjetEntite: 'Jours' }
  ];

  listProgram = [
    { id: 1, libelleObjetEntite: 'Jour du mois' },
    { id: 0, libelleObjetEntite: 'Jour de la semaine' },
    { id: 2, libelleObjetEntite: 'Jour et semaine du mois' },
    { id: 3, libelleObjetEntite: 'Dernière semaine du mois' },
  ];

  listSemaine = [
    { id: 2, libelleObjetEntite: 'LUN' },
    { id: 3, libelleObjetEntite: 'MAR' },
    { id: 4, libelleObjetEntite: 'MER' },
    { id: 5, libelleObjetEntite: 'JEU' },
    { id: 6, libelleObjetEntite: 'VEN' },
    { id: 7, libelleObjetEntite: 'SAM' },
    { id: 1, libelleObjetEntite: 'DIM' },
  ];

  dataMotifSuppression = [];
  motifSuppression = {};

  listJour = [];
  nbSemainesProgram = '1';

  protected listChantier = [];

  public isOpen: Boolean = false;

  public selectedChantier = {};
  public mouvBenneProgramme = {};
  public selectedAdress = {};
  public showEquipe: Boolean = false;
  public isJourFerie: Boolean = false;
  public isSuspension: Boolean = false;
  public equipes: any[] = [];
  public listpresta: any[] = [];
  public listMateriel: any[] = [];
  public listLog: any[] = [];
  showMsg: boolean;
  showDoc: boolean;
  isProgrammation: Boolean = false;
  isQtePrevisionnelle: Boolean = false;

  isDepuisEcocrm: Boolean = false;
  isDepuisEcocontrat: Boolean = false;

  objectFocus = {};
  objectoldFocus = {};
  client: any = {};

  listExutoire = [];
  objEquipe = {};
  isModeEquipe: Boolean = false;
  listPeriode: any = [];
  defaultPeriode: any = {};
  societe: any = {};
  isShowSite: Boolean = false;
  listeSite = [];
  listeSiteCA = [];
  defaultSite: any = {};
  defaultSiteCA: any = {};
  listIndispoChauff = [];

  isPlusPrest: Boolean = false;
  listeLocationsAnnules = [];
  listeLocationsSupplementaires = [];
  listeLocationsProgrammees = [];

  // sygetrack
  isSygetrack: Boolean = false
  callSygetrack = '';
  msgSygetrack = '';
  nomInformatiqueImbrique = 'Sygetrack'; // Par défaut
  
  @ViewChild('loadingSygetrack') loadingSygetrack;

  constructor(public common: CommonService, protected alert: AlertService, private modalService: BsModalService) {
  }

  async ngOnInit() {
    console.log('_______NG ON INIT CREATE PRESTATION COMPONENT _________');
    const ctrl = this;


    this.isDepuisEcocrm = this.moduleSource && this.moduleSource == 'ecocrm' ? true : false;
    this.isDepuisEcocontrat = this.moduleSource && this.moduleSource == 'ecocontrat' ? true : false;
    console.log('is_create', this.is_recreate);
    this.height = ($(window).height() - 49);
    this.param = this.common.local.getObject('paramSociete') || {};
    this.societe = this.param;
    this.isQtePrevisionnelle = this.param['qtePrevisionnelle'] || false;
    this.user = this.common.local.getObject('userDetail');

    const siteUser = this.common.getType('siteUtilisateur');
    this.isSygetrack = this.param['isSygetrack'] && siteUser['isGPS'];

    for (let i = 0; i < 31; i++) {
      this.listJour.push({ id: i + 1, libelleObjetEntite: i + 1 });
    }
    const listSupp = [{ id: -1, libelleObjetEntite: 1 },
    { id: -1, libelleObjetEntite: 2 },
    { id: -1, libelleObjetEntite: 3 },
    { id: -1, libelleObjetEntite: 4 }];
    this.listJour = [...this.listJour, ...listSupp];

    const listeSite = this.common.getType('tousSite') || [];

    this.getlistMotifSuppressionEcoloc();
    if (!listeSite.length) {
      this.getListeSite();
    } else {
      this.isShowSite = listeSite.length > 1 ? true : false;
      this.listeSite = listeSite;
      this.listeSite.forEach(elt => {
        if (elt.id === this.common.user[2]) {
          this.defaultSite = elt;
          this.defaultSiteCA = elt;
        }
      });
    }

    // this.planning = this.planning || {};
    this.eventSelected = this.eventSelected || {};
    if (this.planning && this.planning['clefBonOrigine']) {
      console.log('this.planing', this.planning)
      this.step = 7;
      this.selectedChantier = this.planning['chantier'];
      this.planning['chauffeur'].nom = `${this.planning['chauffeur'].nom || ''} ${this.planning['chauffeur'].prenom || ''}`;
      this.equipes.push(this.planning['chauffeur']);
      this.planning['listePersonnelParPoste'].forEach(elt => {
        elt['chauffeur'].nom = `${elt['chauffeur'].nom || ''} ${elt['chauffeur'].prenom || ''}`;
        this.equipes.push(elt['chauffeur']);
      });
      if (this.planning['listPrestation']) {
        this.listpresta = this.planning['listPrestation'];
      } else {
        const event = this.planning['prestation'] || { id: 0 };
        if (event && event.id) {
          this.getDetailArticle(event.id).then(datas => {
            const article = datas[0] || null;
            if (article !== null) {
              this.isDIS = article.isDIS || false;
              console.log('isDIS =', this.isDIS);
            }
          });
        }
      }
      this.showEquipe = true;
      if (this.planning['infofact'] || this.planning['infosupp']) {
        this.planning['showInfo'] = true;
      } else {
        this.planning['showInfo'] = false;
      }
      const site = this.planning['sitePrest'] ?
        this.planning['sitePrest'].id : this.common.user[2];
      const siteCA = this.planning['siteCA'] ?
        this.planning['siteCA'].id : this.common.user[2];

      this.listeSite.forEach(elt => {
        if (elt.id === site) {
          this.defaultSite = elt;
          this.planning['sitePrest'] = elt;
        }
        if (elt.id === siteCA) {
          this.defaultSiteCA = elt;
          this.planning['siteCA'] = elt;
        }
      });
      if (this.isShowSite) {
        this.planning['showSite'] = true;
      }
      this.planning['modeEquipe'] = this.eventSelected['detail'] && this.eventSelected['detail'].materielLoue ?
        this.eventSelected['detail'].materielLoue.equipeDefinie || false : false;
      this.parseMouvement();
      this.focusStep();
    }
    console.log(this.eventSelected['detail'], this.planning);

    this.rappelValueUpdate();

    if (this.isEdit) {
      if (this.param['gestionCQC']) {
        this.planning['partenaire'] = this.eventSelected['detail'].chauffeurPrestataire;
        // console.log(this.planning['partenaire']);
      }
      if (this.eventSelected['detail'].materielLoue) {
        if (this.eventSelected['detail'].materielLoue.program) {
          this.planning['program'] = true;
        }
        this.mouvBenneProgramme = this.eventSelected['detail'].materielLoue.program || {};
        this.mvtProgramme();
      }

      if (this.eventSelected['detail'].periode) {
        this.getListPeriode().then((res) => {
          this.listPeriode.forEach(p => {
            if (p.id === this.eventSelected['detail'].periode.id) {
              this.planning['periode'] = p;
              this.defaultPeriode = p;
            }
          });
        })
      }

      this.isHistoLoc = this.isHistoLoc || (this.eventSelected['detail'].histo || false)

      this.planning['client'] = this.eventSelected['detail'].client || { id: 0 };
      this.planning['chantier'] = this.eventSelected['detail'].chantier || { id: 0 };
      this.eventSelected['detail'].camion = this.eventSelected['detail'].camion || { id: 0 };

      if (this.eventSelected['detail'] && this.eventSelected['detail']['listMateriel'] && this.eventSelected['detail']['listMateriel'].length) {
        this.eventSelected['detail']['listMateriel'].forEach(camion => {
          camion.libelleEdit = `${camion.numParc ? camion.numParc + ' / ' : ''}${camion.immatriculation || ''}`;
          camion.libelleObjetEntite = camion.libelleEdit;
        });
        this.planning['listMateriel'] = this.eventSelected['detail']['listMateriel'];
        this.listMateriel = this.planning['listMateriel'];
        this.planning['multiCamion'] = true;
      } else if (this.eventSelected['detail'].camion && this.eventSelected['detail'].camion.id) {
        this.eventSelected['detail'].camion.libelleEdit = `${this.eventSelected['detail'].camion.numParc ?
          this.eventSelected['detail'].camion.numParc + ' / ' : ''}${this.eventSelected['detail'].camion.immatriculation || ''}`;
        this.planning['machine'] = Object.assign({}, this.eventSelected['detail'].camion);
      }

      this.planning['date'] = this.planning['dateStart'];
      this.planning['modeEquipe'] = this.eventSelected['detail'] && this.eventSelected['detail'].materielLoue ?
        this.eventSelected['detail'].materielLoue.equipeDefinie || false : false;

      if (this.eventSelected['detail'] && this.eventSelected['detail']['listPrestation'] && this.eventSelected['detail']['listPrestation'].length) {
        this.eventSelected['detail']['multiPrestation'] = true;
      }


      this.planning['isAcompte'] = this.eventSelected && this.eventSelected['detail'] && this.eventSelected['detail'].facturation ? true : false;
      this.planning['acompte'] = parseFloat(this.eventSelected && this.eventSelected['detail'] && this.eventSelected['detail'].facturation ? this.eventSelected['detail'].facturation || 0 : 0).toFixed(2);

      let numContrat = this.eventSelected && this.eventSelected['detail'] && this.eventSelected['detail'].contrat ? (this.eventSelected['detail'].contrat.numContrat || '') : '';
      numContrat = numContrat !== '' ? numContrat : this.eventSelected['detail'].numContrat || '';
      this.planning['isContrat'] = numContrat !== '' ? true : false;
      this.planning['numContrat'] = numContrat;

      this.planning['numBSDD'] = this.eventSelected && this.eventSelected['detail'] && this.eventSelected['detail'].bon && this.eventSelected['detail'].bon.numBSDManuel ? this.eventSelected['detail'].bon.numBSDManuel : '';

      this.planning['prestation'] = this.eventSelected['detail'].article || { id: 0 };
      const event = this.planning['prestation'] || { id: 0 };
      if (event && event.id) {
        this.getDetailArticle(event.id).then(datas => {
          const article = datas[0] || null;
          if (article !== null) {
            this.isDIS = article.isDIS || false;
            console.log('isDIS =', this.isDIS);
          }
        });
      }

      this.planning['prestation'].libelleObjetEntite = `${(this.planning['prestation'].code ? this.planning['prestation'].code + '/' : '') + (this.planning['prestation'].libelle || this.planning['prestation'].libelleObjetEntite || '')}`;
      this.planning['exutoire'] = this.eventSelected['detail'].exutoire || { id: 0 };
      if (this.planning['chantier'] && this.planning['chantier'].id) {
        this.getDetailChantier(this.planning['chantier']['id']).then(datas => {
          this.selectedChantier = datas.data && datas.data.length ? datas.data[0] : this.planning['chantier'];
          this.planning['chantier'] = datas.data && datas.data.length ? datas.data[0] : this.planning['chantier'];
          this.eventSelected['detail'].chantier = datas.data && datas.data.length ? datas.data[0] : this.planning['chantier'];
          this.objEquipe['listLieu'] = this.selectedChantier['listLieu'] || [];
          $('#slide-right').trigger('click');
        });
      }
      const site = this.eventSelected['detail'] && this.eventSelected['detail'].site ?
        this.eventSelected['detail'].site.id : this.common.user[2];
      const siteCA = this.eventSelected['detail'] && this.eventSelected['detail'].siteCA ?
        this.eventSelected['detail'].siteCA.id : this.common.user[2];

      this.listeSite.forEach(elt => {
        if (elt.id === site) {
          this.defaultSite = elt;
          this.planning['sitePrest'] = elt;
        }
        if (elt.id === siteCA) {
          this.defaultSiteCA = elt;
          this.planning['siteCA'] = elt;
        }
      });

      this.parseMouvement();

      if ((this.eventSelected['detail'].materielLoue && this.eventSelected['detail'].materielLoue.id)) {
        if (this.isDepuisEcocontrat) { // Pas besoin de rappeler le detail d'un materielLoue pour obtenir les listeLocations et en plus c'est materielLoueContrat
          const listeLocations = this.eventSelected['detail'].materielLoue.listeLocations || [];
          listeLocations.forEach(locSup => {
            const locSupId = locSup.id || 0;
            const detailId = ctrl.eventSelected['detail'].id || 0;
            if (!locSup.indisponibilite && !locSup.histo && locSupId != detailId) {
              if (locSup.annule) {
                this.listeLocationsAnnules.push(locSup);
              } else if (locSup.horsProgram) {
                this.listeLocationsSupplementaires.push(locSup);
              } else {
                this.listeLocationsProgrammees.push(locSup);
              }
            }
          });

          this.listeLocationsAnnules = [...this.listeLocationsAnnules];
          this.listeLocationsSupplementaires = [...this.listeLocationsSupplementaires];
          this.listeLocationsProgrammees = [...this.listeLocationsProgrammees];

          this.planning['checkPlusieursLocations'] = this.listeLocationsSupplementaires.length > 0;
          console.log('this.planning[listeLocationsSupplementaires]', this.planning['listeLocationsSupplementaires']);
        } else {
          this.getMaterielLoue(this.eventSelected['detail'].materielLoue.id, this.eventSelected['detail'].horsProgram).then(datas => {
            if (datas.data && datas.data.length == 2 && datas.data[1].length) {
              const listeLocations = datas.data[1];
              // Dans AI on a this.eventSelected['detail'].materielLoue = datas.data mais peut provoquer une regression ici
              listeLocations.forEach(locSup => {
                const locSupId = locSup.id || 0;
                const detailId = ctrl.eventSelected['detail'].id || 0;
                if (!locSup.indisponibilite && !locSup.histo && locSupId != detailId) {
                  if (locSup.annule) {
                    this.listeLocationsAnnules.push(locSup);
                  } else if (locSup.horsProgram) {
                    this.listeLocationsSupplementaires.push(locSup);
                  } else {
                    this.listeLocationsProgrammees.push(locSup);
                  }
                }
              });

              this.listeLocationsAnnules = [...this.listeLocationsAnnules];
              this.listeLocationsSupplementaires = [...this.listeLocationsSupplementaires];
              this.listeLocationsProgrammees = [...this.listeLocationsProgrammees];

              this.planning['checkPlusieursLocations'] = this.listeLocationsSupplementaires.length > 0;
              console.log('this.planning[listeLocationsSupplementaires]', this.planning['listeLocationsSupplementaires']);
            }
          });
        }
      }
    }

    if (this.isDepuisEcocrm || (this.isDepuisEcocontrat && !this.isEdit)) {
      if (this.planning['listPrestation']) {
        this.listpresta = this.planning['listPrestation'];
      }

      this.setValuePlanning(this.planning['client'], 'client');
    }
    await this.getListPeriode();

    this.getNomInformatiqueEmbarque();
  }
  
  getNomInformatiqueEmbarque() {
    if (this.common.isSiteSygetrack(true)) {
      const ctrl = this;
      GestionSygetrack.getNomInformatiqueEmbarque(this.common).then(datas => {
        ctrl.nomInformatiqueImbrique = datas.data;
      });
    }
  }

  // get list location
  getMaterielLoue(clefMaterielLoue, horsProgram) {
    const param = {
      'servlet': 'DBGestionMaterielLoue',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_LOCATION_MATERIEL': {
          'typeParam': 'int',
          'valeur': clefMaterielLoue
        },
        'CHARGER_LISTE_LOCATIONS': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CHARGER_LISTE_LOCATIONS_HORS_PROGRAMME': {
          'typeParam': 'boolean',
          'valeur': !horsProgram ? true : false
        },
        'IS_ANGULAR': {
          'typeParam': 'boolean',
          'valeur': true
        }
      }
    };

    return this.common.post('', { param: param });
  }

  showPlusPrest() {
    if (this.planning['checkPlusieursLocations']) {
      this.isPlusPrest = !this.isPlusPrest;
    } else {
      this.annulerToutesLesLocationsFilles();
    }
  }

  // $event = listeLocationsSupplementaires
  savePlusPrest($event) {
    // console.log('Calling savePlusPrest()');
    // console.log($event);
    // console.log('_______obj equipe _______', this.objEquipe);
    this.listeLocationsSupplementaires = $event;
    // this.planning['listeLocationsSupplementaires'] = $event;
    this.isPlusPrest = !this.isPlusPrest;
  }

  // annule une location
  savePlusPrestAnnule($event) {
    $event['annule'] = true;
    this.listeLocationsAnnules.push($event);
  }

  annulerToutesLesLocationsFilles() {
    let locationEnregistre = false;
    if (this.listeLocationsSupplementaires.length) {
      this.listeLocationsSupplementaires.forEach(l => {
        if (l.id) {
          locationEnregistre = true;
        }
      });

      if (locationEnregistre) {
        if (this.dataMotifSuppression && this.dataMotifSuppression.length) {
          this.motifSuppression = this.dataMotifSuppression[0];
        }
        this.common.openModal(this.modalService, this.templateSupressionFille);
      }
    }
  }

  confirmDeleteBonFille() {
    this.listeLocationsSupplementaires.forEach(l => {
      if (l.id) {
        if (this.dataMotifSuppression && this.dataMotifSuppression.length) {
          this.motifAnnulationFille = this.motifSuppression && this.motifSuppression['id'] && !this.motifAnnulationFille ?
            (this.motifSuppression['libelle'] || this.motifSuppression['libelleObjetEntite']) : this.motifAnnulationFille;
        }
        l['annule'] = true;
        l['motifAnnulation'] = this.motifAnnulationFille;
        l['motifSuppressionEcoloc'] = this.motifSuppression || { id: 0 };
        this.listeLocationsAnnules.push(Object.assign({}, l));
      }
    });

    this.listeLocationsSupplementaires = [];
    this.common.closeModal();
  }

  ngOnChanges(changes) {
    if (!this.isEdit && !this.planning['clefBonOrigine']) {
      if (this.selectedEvent['resource']) {
        this.equipes.push({
          id: this.selectedEvent['resource'].id,
          nom: this.selectedEvent['resource'].title,
          type: 'leader'
        });
        // console.log(this.selectedEvent['resource']);
        this.planning['chauffeur'] = {
          id: this.selectedEvent['resource'].id,
          nom: this.selectedEvent['resource'].title,
          type: 'leader'
        };
        this.parseMouvement();
      }
    }
  }

  getListPeriode() {
    const param = {
      'servlet': 'DBGestionPeriode',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data != null) {
        this.listPeriode = datas.data;
      }
    });
  }

  changeChantier(item) {
    this.selectedChantier = item;
  }

  rappelValueUpdate() {
    if (this.isEdit && this.eventSelected) {
      if (this.eventSelected['detail'] && this.eventSelected['detail'].rappelActif) {
        if (!this.eventSelected['detail'].rappelLibre) {
          const date = this.eventSelected['detail'].dateDebut + ' ' + this.eventSelected['detail'].heureDebut;
          const dateDebut = moment(date, 'DD/MM/YYYY HH:mm:ss');
          const rapel = moment(this.eventSelected['detail'].rappel, 'DD/MM/YYYY HH:mm:ss');
          switch (dateDebut.diff(rapel, 'hours', true)) {
            case 0.08333333333333333:
              this.selected = this.rappel[1];
              break;
            case 0.25:
              this.selected = this.rappel[2];
              break;
            case 0.5:
              this.selected = this.rappel[3];
              break;
            case 1:
              this.selected = this.rappel[4];
              break;
            case 2:
              this.selected = this.rappel[4];
              break;
            case 24:
              this.selected = this.rappel[5];
              break;
            case 48:
              this.selected = this.rappel[6];
              break;
          }
        } else {
          const date = this.eventSelected['detail'].dateDebut + ' ' + this.eventSelected['detail'].heureDebut;
          const dateDebut = moment(date, 'DD/MM/YYYY HH:mm:ss');
          const rapel = moment(this.eventSelected['detail'].rappel, 'DD/MM/YYYY HH:mm:ss');
          const min = dateDebut.diff(rapel, 'minutes', true);
          const heur = dateDebut.diff(rapel, 'hours', true);
          const day = dateDebut.diff(rapel, 'days', true);
          if (this.eventSelected['detail'].valeurRappelLibre === min) {
            this.planning['rappelLibre'] = this.typerappel[0];
          } else {
            if (this.eventSelected['detail'].valeurRappelLibre === heur) {
              this.planning['rappelLibre'] = this.typerappel[1];
            } else {
              if (this.eventSelected['detail'].valeurRappelLibre === day) {
                this.planning['rappelLibre'] = this.typerappel[2];
              }
            }
          }
        }
      }
    }
  }

  afficheLeader() {
    if (!this.isEdit && !this.planning['clefBonOrigine']) {
      if (this.equipes && this.equipes.length) {
        const leader = this.equipes[0];
        return `${leader.matricule ? leader.matricule + ' ' : ''}
        ${leader.nom ? leader.nom + ' ' : ''}${leader.prenom ? leader.prenom : ''}`;
      }
    } else {
      const leader = this.eventSelected && this.eventSelected.detail && this.eventSelected.detail.chauffeur ?
        this.eventSelected.detail.chauffeur : { id: 0, libelleObjetEntite: 'Aucun' };

      return `${leader.matricule ? leader.matricule + ' ' : ''}${leader.nom ? leader.nom + ' ' : ''}${leader.prenom ? leader.prenom : ''}`;
    }
  }

  showBtn() {
    this.isOpen = !this.isOpen;
  }

  setValuePlanning(value, name?) {
    if (this.isHistoLoc) {
      this.modifier = false;
      return true;
    }
    console.log('Calling setValuePlanning()' + (name ? name : 'noname'));
    console.log('this.isEdit=' + this.isEdit);
    console.log('this.step=' + this.step);
    console.log(value);

    if (this.isEdit) {
      console.log('Concerne this.isEdit=true');
      this.showBtnvalid = true;
      $('[tabindex=0]').focus();
      switch (this.step) {
        case 1:
          if (name === 'client') {
            if (value) {
              this.getDetailClient(value.id).then(() => {
                if (this.client['codeBlocage'] && (this.client['codeBlocage'] === 3 || this.client['codeBlocage'] === 4 ||
                  this.client['codeBlocage'] === 5 || this.client['codeBlocage'] === 10)) {
                  this.error = `Client bloqu\u00e9.\nVeuillez consulter votre administrateur pour le d\u00e9bloquer.`;
                  this.step = 1;
                  this.showBtnvalid = false;
                  this.common.openModal(this.modalService, this.msg);
                  return false;
                } else {
                  this.eventSelected['detail'].client.id = value.id;
                  this.eventSelected['detail'].client.nomClient = value.libelleObjetEntite;

                  // if(!this.isDepuisEcocontrat) {
                  this.eventSelected['detail'].chantier = {};
                  //}
                }
              });
            }

          } else {
            if (this.eventSelected['detail'].bon.clientDemandeur) {
              this.eventSelected['detail'].bon.clientDemandeur.id = value.id;
              this.eventSelected['detail'].bon.clientDemandeur.nomClient = value.libelleObjetEntite;
            } else {
              this.planning[name] = value;
            }
          }
          break;
        case 2:
          this.eventSelected['detail'].chantier = value;
          break;
        case 4:
          if (!this.planning['multiPrestation']) {
            this.eventSelected['detail']['multiPrestation'] = false;
            this.eventSelected['detail'].article = this.eventSelected['detail'].article ?
              this.eventSelected['detail'].article : {};
            this.eventSelected['detail'].article.id = value.id;
            this.eventSelected['detail'].article.libelle = value.libelleObjetEntite;
          } else {
            this.eventSelected['detail']['multiPrestation'] = true;
          }

          break;
        case 4.1:
          this.eventSelected['detail'].exutoire = this.eventSelected['detail'].exutoire || {};
          this.eventSelected['detail'].exutoire.id = value.id;
          this.eventSelected['detail'].exutoire.libelleEdit = value.libelleObjetEntite;
          break;
        case 5:
          const heurestart = this.planning['hourStart'] ? this.planning['hourStart'] :
            this.eventSelected['detail'].heureDebut.slice(0, -6);
          const minstart = this.planning['minStart'] ? this.planning['minStart'] : '00';
          const heurefin = this.planning['hourEnd'] ? this.planning['hourEnd'] :
            this.eventSelected['detail'].heureFin.slice(0, -6);
          const minfin = this.planning['minEnd'] ? this.planning['minEnd'] : '00';
          if (this.planning['periode']) {
            this.eventSelected['detail'].periode = this.planning['periode'];
          }
          this.eventSelected['detail'].dateDebut = this.planning['dateStart'] ?
            moment(this.common.parseDate(this.planning['dateStart'])).format('DD/MM/YYYY') :
            this.eventSelected['detail'].dateDebut;
          this.eventSelected['detail'].dateFin = this.planning['dateEnd'] ?
            moment(this.common.parseDate(this.planning['dateEnd'])).format('DD/MM/YYYY') :
            this.eventSelected['detail'].dateFin;
          this.eventSelected['detail'].heureDebut = heurestart + ':' + minstart + ':00';
          this.eventSelected['detail'].heureFin = heurefin + ':' + minfin + ':00';
          break;
        case 6:
          this.eventSelected['detail'].camion = this.eventSelected['detail'].camion || {};
          this.eventSelected['detail'].camion.id = value.id;
          this.eventSelected['detail'].camion['immatriculation'] = value['immatriculation'] || '';
          this.eventSelected['detail'].camion['numParc'] = value['numParc'] || '';
          break;
        case 9:
          this.eventSelected['detail'].infosFact = this.planning['infofact'];
          this.eventSelected['detail'].infosSup = this.planning['infosupp'];
          break;
      }
      this.modifier = false;
      setTimeout(function () {
        $('#btnvalider').focus();
      }, 500);
    }
    if (name) {
      this.planning[name] = value;
      this.objectFocus = {};
      if (name === 'client') {
        if (!this.isDepuisEcocrm) {
          this.planning['chantier'] = false;
        } else if (this.planning['chantier'] && this.planning['chantier'].id) {
          this.selectedChantier = this.planning['chantier'];
        } else {
          this.selectedChantier = {};
        }

        this.planning['adresse'] = false;
        this.getDetailClient(value.id).then(() => {
          if (this.client['codeBlocage'] && (this.client['codeBlocage'] === 3 || this.client['codeBlocage'] === 4 ||
            this.client['codeBlocage'] === 5 || this.client['codeBlocage'] === 10)) {
            this.error = `Client bloqu\u00e9.\nVeuillez consulter votre administrateur pour le d\u00e9bloquer.`;
            this.step = 1;
            this.showBtnvalid = false;
            this.planning['client'] = false;
            this.common.openModal(this.modalService, this.msg);
            return false;
          }
        });
      }
    }
    if (!this.isEdit) {
      if (this.step === 1) {
        if (!this.planning['client'] || (this.planning['client'] && !this.planning['client']['id'])) {
          $('.client1').focus();
          this.planning['showInfo'] = false;
          this.planning['client'] = false;
          return;
        }
      }
      if (this.step === 2) {
        this.selectedChantier = value;
        if (!this.selectedChantier || (this.selectedChantier && !this.selectedChantier['id'])) {
          $('.autoCht').focus();
          this.planning['chantier'] = false;
          return;
        } else {
          this.getDetailChantier(this.selectedChantier['id']).then(datas => {
            this.selectedChantier = datas.data[0];
            this.planning['chantier'] = datas.data[0];
            this.objEquipe['listLieu'] = this.selectedChantier['listLieu'] || [];
            $('#slide-right').trigger('click');
          });
        }
      }

      if (this.step === 7) {
        this.showEquipe = true;
        /*if (this.param['gestionCQC']) {
          this.step = 7;
          this.planning['isPartenaire'] = true;
        }*/
      }

      if (name === 'showDate') {
        this.planning['hourStart'] = this.planning['hourStart'] || '00';
        this.planning['minStart'] = this.planning['minStart'] || '00';
        this.planning['hourEnd'] = this.planning['hourEnd'] || '00';
        this.planning['minEnd'] = this.planning['minEnd'] || '00';
      }

      if (this.planning['client']) {
        if (this.step === 3 && this.isShowSite) {
          this.step = 3.1;
        } else {
          if (this.step === 3.1) {
            this.step = 4;
          } else {
            if (this.step === 7) {
              if (this.param['gestionCQC']) {
                if (!this.planning['partenaire']) {
                  this.step = 7;
                  this.planning['isPartenaire'] = true;
                } else {
                  this.step = 7.1;
                }
              } else {
                this.step = 7.1;
              }
            } else {

              if (this.step === 7.1) {
                this.step = 8;
              } else {
                this.step = this.step === 4 ? 4.1 : (this.step === 4.1 ? 5 : (this.step < 9 ? this.step + 1 : 9));
              }
            }
          }

        }


      } else {
        $('.client1').focus();
        this.planning['showInfo'] = false;
      }

      if (this.step === 3) {
        setTimeout(function () {
          $('#autofocus').focus();
        }, 500);
      }
      if (this.step === 5) {
        setTimeout(function () {
          $('#date1').focus();
        }, 500);
      }
      if (this.step === 8) {
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      }
      this.focusStep();
    }

    console.log('this.step après=' + this.step)
  }

  getDetailArticle(id) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetArticle', clef]
    };
    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  // select sur le combo
  validerChoixComboPrestation(event) {
    if (this.isEdit) {
      if (!this.planning['multiPrestation']) {
        this.eventSelected['detail'].article = this.eventSelected['detail'].article ?
          this.eventSelected['detail'].article : {};
        this.eventSelected['detail'].article.id = event.id;
        this.eventSelected['detail'].article.libelle = event.libelleObjetEntite;
        this.eventSelected['detail'].article.libelleObjetEntite = event.libelleObjetEntite;
        this.eventSelected['detail'].article.code = '';
        // console.log(this.eventSelected['detail'].article);
      }
    }

    if (this.isQtePrevisionnelle) {
      this.planning['prestation'] = event;
      this.common.focusElement('#fieldQtePrev');
    } else {
      this.setValuePlanning(event, 'prestation');
    }
    this.getDetailArticle(event.id).then(datas => {
      const article = datas[0] || null;
      if (article !== null) {
        this.isDIS = article.isDIS || false;
        console.log('isDIS =', this.isDIS);
      }
    });

  }

  // click sur le bouton OK du choix de la prestation
  validerChoixPrestation(event) {
    // console.log('Calling validerChoixPrestation()');
    // console.log(event);

    if (this.isQtePrevisionnelle) {
      if (!this.planning.multiPrestation) {
        this.planning['qtePrevisionnelle'] = this.planning['qtePrevisionnelle'] || 0;
        this.setValuePlanning(this.isEdit ? this.eventSelected['detail'].article : event);
      } else {
        this.setValuePlanning(this.listpresta, 'listPrestation');
      }
    } else {
      if (!this.planning.multiPrestation) {
        if (this.isDepuisEcocrm) {
          this.setValuePlanning(this.planning['prestation'] || event, 'prestation');
        } else {
          this.setValuePlanning(event, 'prestation');
        }
      } else {
        if (this.isDepuisEcocrm) {
          this.setValuePlanning(this.planning['listPrestation'], 'listPrestation');
        } else {
          this.setValuePlanning(this.listpresta, 'listPrestation');
        }
      }
    }

    // console.log(this.planning);
  }

  validerChoixMateriel(event) {
    if (!this.planning.multiCamion) {
      if (this.isDepuisEcocrm) {
        this.setValuePlanning((this.planning.machine ? this.planning.machine : { id: 0, libelleObjetEntite: '' }) || event, 'machine');
      } else {
        this.setValuePlanning((this.planning.machine ? this.planning.machine : { id: 0, libelleObjetEntite: '' }), 'machine');
      }
    } else {
      if (this.isDepuisEcocrm) {
        this.setValuePlanning(this.planning['listMateriel'], 'listMateriel');
      } else {
        this.setValuePlanning(this.listMateriel, 'listMateriel');
      }
    }
  }

  changerQtePrev(event) {
    if (this.isEdit) {
      if (!this.eventSelected['detail'].article) {
        this.eventSelected['detail'].article = {};
        this.eventSelected['detail'].article['qtePrevisionnelle'] = event;
      } else {
        this.eventSelected['detail'].article['qtePrevisionnelle'] = event;
      }
    }
    this.planning.qtePrevisionnelle = event;
  }

  addLigneMultiPrestation() {
    if (!this.isEdit) {
      this.listpresta.push({ id: 0, libelle: '', qtePrevisionnelle: 0 });
      this.listpresta = [...this.listpresta];
      console.log(this.listpresta);
    } else {
      this.eventSelected['detail'].listPrestation.push({ id: 0, libelle: '', qtePrevisionnelle: 0 });
      this.eventSelected['detail'].listPrestation = [...this.eventSelected['detail'].listPrestation];
      console.log(this.eventSelected['detail'].listPrestation);
    }
  }

  addLigneMultiCamion() {
    if (!this.isEdit) {
      this.listMateriel.push({ id: 0, libelle: '' });
      this.listMateriel = [...this.listMateriel];
      console.log(this.listMateriel);
    } else {
      this.eventSelected['detail'].listMateriel.push({ id: 0, libelle: '' });
      this.eventSelected['detail'].listMateriel = [...this.eventSelected['detail'].listMateriel];
      console.log(this.eventSelected['detail'].listMateriel);
    }
  }

  deleteLigneMultiPrestation(row) {
    if (this.isEdit) {
      const temp = this.eventSelected.detail.listPrestation.filter(elt => elt !== row);
      this.eventSelected.detail.listPrestation = temp;
    } else {
      const temp = this.listpresta.filter(elt => elt !== row);
      this.listpresta = temp;
    }
  }

  deleteLigneMultiCamion(row) {
    if (this.isEdit) {
      const temp = this.eventSelected.detail.listMateriel.filter(elt => elt !== row);
      this.eventSelected.detail.listMateriel = temp;
    } else {
      const temp = this.listMateriel.filter(elt => elt !== row);
      this.listMateriel = temp;
    }
  }

  selectArticleMultiPrestation(event, row) {
    row['id'] = event.id;
    row['libelle'] = event.libelleObjetEntite;
    row['libelleObjetEntite'] = event.libelleObjetEntite;
  }

  selectCamionMultiCamion(event, row) {
    row['id'] = event.id;
    row['libelle'] = event.libelleObjetEntite;
    row['libelleObjetEntite'] = event.libelleObjetEntite;
    row['immatriculation'] = event['immatriculation'] || '';
    row['numParc'] = event['numParc'] || '';
  }


  selectExutoireMultiPrestation(event, row) {
    row['exu'] = {};
    row['exu'].id = event.id;
    row['exu'].libelle = event.libelleObjetEntite;
    row['exu'].libelleObjetEntite = event.libelleObjetEntite;
    row['exu'].nom = event.libelleObjetEntite;
  }

  countRowsInText(text) {
    if (text) {
      const numerOfRowsInText = text.length ? text.split(/\r*\n/).length : 0;
      return numerOfRowsInText <= 3 ? 3 : 10;
    } else {
      return 3;
    }
  }

  addEquipe(event) {
    let add = false;
    if (!this.isEdit) {
      this.equipes.forEach(data => {
        if (parseInt(data.id, 10) === event.id) {
          add = true;
        }
      });
      if (this.param['ecolocEquipe']) {
        if (!add) {
          this.equipes.push({ id: event.id, nom: event.libelleObjetEntite });
        }
      } else {
        this.equipes = [{ id: event.id, nom: event.libelleObjetEntite }];
      }
      // if (!add) {
      //   this.equipes.push({ id: event.id, nom: event.libelleObjetEntite });
      // }
    } else {
      if (this.param['ecolocEquipe']) {
        if (this.eventSelected['detail'].chauffeur && this.eventSelected['detail'].chauffeur.id !== 0) {
          this.eventSelected['detail'].listePersonnelParPoste.forEach(data => {
            if (data.chauffeur) {
              if (parseInt(data.chauffeur.id, 10) === event.id || this.eventSelected['detail'].chauffeur.id === event.id) {
                add = true;
              }
            }
          });
          if (!add) {
            this.eventSelected['detail'].listePersonnelParPoste.push({
              chauffeur: { id: event.id, nom: event.libelleObjetEntite }
            });
          }
        } else {
          this.eventSelected['detail'].chauffeur = { id: event.id, nom: event.libelleObjetEntite };
        }
      } else {
        this.eventSelected['detail'].chauffeur = { id: event.id, nom: event.libelleObjetEntite };
      }
    }
    setTimeout(function () {
      $('#autocomplete').focus();
    }, 500);
  }

  addPresation(event) {
    let add = false;
    if (!this.isEdit) {
      this.listpresta.forEach(data => {
        if (parseInt(data.id, 10) === event.id) {
          add = true;
        }
      });
      if (!add) {
        this.listpresta.push(event);
      }
    } else {
      this.eventSelected['detail'].listPrestation = this.eventSelected['detail'].listPrestation || [];
      this.eventSelected['detail'].listPrestation.forEach(data => {
        if (data.id === event.id) {
          add = true;
        }
      });
      if (!add) {
        this.eventSelected['detail'].listPrestation.push({ id: event.id, libelle: event.libelleObjetEntite });
      }
    }
    setTimeout(function () {
      $('#autocomplete').focus();
    }, 500);
  }

  deleteEquipe(item) {
    if (!this.isEdit) {
      this.equipes = this.equipes.filter(elt => elt.id !== item.id);
    } else {
      this.showBtnvalid = true;
      this.eventSelected['detail'].listePersonnelParPoste = this.eventSelected['detail'].listePersonnelParPoste
        .filter(elt => elt.chauffeur.id !== item.chauffeur.id);
    }
  }

  deletePresta(item) {
    if (!this.isEdit) {
      this.listpresta = this.listpresta.filter(elt => elt.id !== item.id);
    } else {
      this.showBtnvalid = true;
      this.eventSelected['detail'].listPrestation = this.eventSelected['detail'].listPrestation
        .filter(elt => elt.id !== item.id);
    }
  }


  getTypeRappelLibre() {
    const start = this.common.parseDate(this.planning['dateStart'], this.planning['hourStart'], this.planning['minStart']);
    const date = this.eventSelected['detail'].heureDebut.slice(0, -10);
  }

  deleteEvent(id) {
    const index: number = this.findEventIndexById(id);
    if (index >= 0) {
      this.events.splice(index, 1);
    }
    this.dialogVisible = false;
  }

  findEventIndexById(id: number) {
    let index = -1;
    for (let i = 0; i < this.events.length; i++) {
      if (id === this.events[i].id) {
        index = i;
        break;
      }
    }
    return index;
  }

  prevStep() {
    if (this.step === 4 && this.isShowSite) {
      this.step = 3.1;
      this.focusStep();
      return false;
    }
    if (this.step === 4 && !this.isShowSite) {
      this.step = 3;
      this.focusStep();
      return false;
    }

    if (this.step === 3.1) {
      this.step = 3;
      this.focusStep();
      return false;
    }
    if (this.param['gestionCQC'] && this.planning['isPartenaire']) {
      if (this.step === 7) {
        this.planning['isPartenaire'] = false;
      } else {
        if (this.step === 7.1) {
          this.step = 7;
          this.planning['isPartenaire'] = true;
        } else if (this.is_recreate && this.step === 4) {
          this.step = 4;
        } else {
          this.step = this.step > 1 ? (this.step === 4.1 ? 4 : (this.step === 5 ? 4.1 : this.step - 1)) : 1;
        }

      }
    } else {
      this.planning['isPartenaire'] = false;
      if (this.step === 7.1) {
        this.step = 7;
        if (this.param['gestionCQC']) {
          this.planning['isPartenaire'] = true;
        }
      } else {
        if (this.is_recreate && this.step === 4) {
          this.step = 4;
        } else {
          this.step = this.step > 1 ? (this.step === 4.1 ? 4 : (this.step === 5 ? 4.1 : this.step - 1)) : 1;
        }
      }

    }
    this.focusStep();
  }

  calculDate() {
    if (this.isEdit) {
      if (!this.planning['changeEnd']) {
        const debut = this.eventSelected['detail'].dateDebut + ' ' + this.eventSelected['detail'].heureDebut;
        const fin = this.eventSelected['detail'].dateFin + ' ' + this.eventSelected['detail'].heureFin;
        const diff = (this.common.getDiffDate(debut, fin, false, true));
        const date = moment(this.planning['dateStart']).add(diff, 'days').format('DD/MM/YYYYY');
        this.planning['dateEnd'] = this.common.parseDate(date);
        if (this.eventSelected['detail'].rappelActif && !this.eventSelected['detail'].rappelLibre) {
          this.selectRappel(this.selected);
        } else {
          this.rappelLibreChange();
        }
      }

    } else {
      if (!this.planning['changeEnd']) {
        this.planning['dateEnd'] = this.planning['dateStart'];
        if (this.planning['showRappel'] && !this.planning['israppelLibre']) {
          this.selectRappel(this.selected);
        } else {
          this.rappelLibreChange();
        }
      }
    }
  }

  calculHour() {
    if (this.isEdit) {
      const debut = this.eventSelected['detail'].heureDebut;
      const fin = this.eventSelected['detail'].heureFin;
      const diff = (this.common.getDiffDate(debut, fin, true));
      const start = new Date().setHours((this.planning['hourStart'] || '00'), (this.planning['minStart'] || '00'));
      const hfin = moment(start).add(diff, 'hours');
      this.planning['hourEnd'] = hfin.format('HH');
      this.planning['minEnd'] = hfin.format('mm');
      if (this.eventSelected['detail'].rappelActif && !this.eventSelected['detail'].rappelLibre) {
        this.selectRappel(this.selected);
      } else {
        this.rappelLibreChange();
      }
    } else {
      if (this.planning['hourStart']) {
        this.planning['hourStart'] = this.planning['hourStart'] || '00';
        this.planning['minStart'] = this.planning['minStart'] || '00';
        this.changeHeureDebut();
      }
      if (this.planning['showRappel'] && !this.planning['israppelLibre']) {
        this.selectRappel(this.selected);
      } else {
        this.rappelLibreChange();
      }
    }
  }

  testHour() {
    const start = new Date().setHours((this.planning['hourStart'] || '00'), (this.planning['minStart'] || '00'));
    const fin = new Date().setHours((this.planning['hourEnd'] || '00'), (this.planning['minEnd'] || '00'));
    const hstart = moment(start).format('HH:mm:ss');
    const hend = moment(fin).format('HH:mm:ss');
    const diff = (this.common.getDiffDate(hstart, hend, true));
    return diff;
  }

  nextStep() {

    if (this.step === 5) {
      if (this.common.getDiffDate(this.planning.dateStart, this.planning.dateEnd, false, true) < 0) {
        return false
      }

      if (this.common.getDiffDate(this.planning.dateStart, this.planning.dateEnd, false, true) === 0 && this.testHour() < 0) {
        return false;
      }
    }
    if (this.step === 1) {
      if (!this.planning['client'] || (this.planning['client'] && !this.planning['client']['id'])) {
        this.focusStep();
        this.planning['client'] = false;
        return;
      }
    }
    if (this.step === 2) {
      if (!this.selectedChantier || (this.selectedChantier && !this.selectedChantier['id'])) {
        $('.autoCht').focus();
        this.planning['chantier'] = false;
        return;
      }
    }

    if (this.step === 3 && this.isShowSite) {
      this.step = 3.1;
    } else {
      if (this.step === 3.1) {
        this.step = 4;
      } else {
        if (this.param['gestionCQC'] && !this.planning['isPartenaire']) {
          if (this.step === 7) {
            this.planning['isPartenaire'] = true;
          } else {
            this.step = this.step === 4 ? 4.1 : (this.step === 4.1 ? 5 : (this.step < 9 ? this.step + 1 : 9));
          }
        } else {
          this.planning['isPartenaire'] = false;
          if (this.step === 7) {
            this.step = 7.1
          } else {
            if (this.step === 7.1) {
              this.step = 8
            } else {
              this.step = this.step === 4 ? 4.1 : (this.step === 4.1 ? 5 : (this.step < 9 ? this.step + 1 : 9));
            }
          }
        }
      }
    }

    this.focusStep();
  }

  nextStepClient() {
    if (this.planning['client'] && this.planning['client'].id) {
      this.getDetailClient(this.planning['client'].id).then(() => {
        if (this.client['codeBlocage'] && (this.client['codeBlocage'] === 3 || this.client['codeBlocage'] === 4 ||
          this.client['codeBlocage'] === 5 || this.client['codeBlocage'] === 10)) {
          this.error = `Client bloqu\u00e9.\nVeuillez consulter votre administrateur pour le d\u00e9bloquer.`;
          this.step = 1;
          this.showBtnvalid = false;
          this.common.openModal(this.modalService, this.msg);
          return false;
        } else {
          this.nextStep()
        }
      });

    } else {
      this.focusStep();
    }
  }

  focusStep() {
    switch (this.step) {
      case 1:
        setTimeout(function () {
          $('.autoClt').focus();
        }, 550);
        break;
      case 2:
        setTimeout(function () {
          $('.autoCht').focus();
        }, 550);
        break;
      case 3:
        setTimeout(function () {
          $('#autofocus').focus();
        }, 550);
        break;
      case 4:
        setTimeout(function () {
          $('.autoPresta').focus();
        }, 550);
        break;
      case 4.1:
        setTimeout(function () {
          $('.autoExutoire').focus();
        }, 550);
        break;
      case 5:
        setTimeout(function () {
          $('#date1').focus();
        }, 550);
        break;
      case 6:
        setTimeout(function () {
          $('.autoMat').focus();
        }, 550);
        break;
      case 7:
        if (this.planning.isPartenaire || !this.param.ecolocEquipe) {
          setTimeout(function () {
            $('.autoPrs').focus();
          }, 550);
        } else {
          if (this.param.ecolocEquipe) {
            setTimeout(function () {
              $('#inputTypeHidden').focus();
            }, 550);
          }
        }

        break;
      case 8:
        if (this.planning['showInfo']) {
          setTimeout(function () {
            $('[tabindex=1]').focus();
          }, 550);
        } else {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        }
        break;
      case 9:
        setTimeout(function () {
          $('#numbsdd').focus();
        }, 550);
        break;
    }
  }

  multiPrestation() {
    this.planning['multiPrestation'] = !this.planning['multiPrestation'];
    if (!this.isEdit) {
      this.planning['prestation'] = {};
      this.planning['listPrestation'] = [];
    } else {
      this.eventSelected['detail'].article = {};
      this.eventSelected['detail'].listPrestation = [];
    }
  }

  multiCamion() {
    this.planning['multiCamion'] = !this.planning['multiCamion'];
    if (!this.isEdit) {
      this.planning['machine'] = {};
      this.planning['listMateriel'] = [];
    } else {
      this.eventSelected['detail'].camion = {};
      this.eventSelected['detail'].listMateriel = [];
    }
  }

  generateBon() {
    if (this.common.getDiffDate(this.planning.dateStart, this.planning.dateEnd, false, true) < 0) {
      this.error = 'La date de début est supérieur à la date de fin.';
      this.common.openModal(this.modalService, this.msg)
      return false;
    }

    if (this.common.getDiffDate(this.planning.dateStart, this.planning.dateEnd, false, true) === 0 && this.testHour() < 0) {
      this.error = ' L\'heure de début est supérieure à l\'heure de fin.';
      this.common.openModal(this.modalService, this.msg)
      return false;
    }

    if (!this.common.isTimeValid(this.formatedHeureDebut()) || !this.common.isTimeValid(this.formatedHeureFin())) {
      this.error = "Le format de l'heure n'est pas valide. Il faut que :\n" +
        "- le format soit de la forme HH:mm:ss\n" +
        "- l'heure ne dépasse pas le 23\n" +
        "- la minute ne dépasse pas le 59";
      this.step = 5;
      this.common.openModal(this.modalService, this.msg);
      return false;
    }

    // console.log('generatebon')
    const equipe = [];
    const equipeMat = [];
    this.showSpinner = true;

    const objetEquipe = this.objMvtEquipe();
    $('.slide-prestation').trigger('click');
    // console.log('a55a', this.planning['dateStart'])
    const date = this.selectedEvent['start'] ?
      new Date(this.selectedEvent['start']) : this.planning['dateStart'];
    this.planning['dateStart'] = this.common.parseDate(this.planning['dateStart']);
    this.planning['dateEnd'] = this.common.parseDate(this.planning['dateEnd']);

    if (this.planning['listPrestation']) {
      this.planning['listPrestation'].forEach(elt => {
        elt.nomclass = 'Article';
        if (elt.exu && elt.exu.id)
          elt.exu.nomclass = 'Exutoire';
      });
    }
    const article = this.planning && !this.planning['multiPrestation'] && this.planning['prestation']
      && this.planning['prestation'].id ? true : false;
    const articleGroupe = this.planning && this.planning['multiPrestation'] && this.planning['listPrestation']
      && this.planning['listPrestation'].length ? true : false;
    if (!article && !articleGroupe) {
      this.error = 'Veuillez sp\u00e9cifier la prestation.';
      this.step = 4;
      this.showSpinner = false;
      this.common.openModal(this.modalService, this.msg);
      return false;
    }

    if (this.planning && this.planning['multiPrestation']) {
      const listArticle = this.planning['listPrestation'] || [];
      const tousIdZero = listArticle.every(elt => elt.id === 0);
      if (tousIdZero) {
        this.error = 'Il faut choisir au moins un aticle ';
        this.step = 4;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
      let retour;
      for (let i = 0; i < listArticle.length; i++) {
        const obj = listArticle[i];
        const articleExiste = listArticle.filter(elt => elt.id === obj.id);
        if ((articleExiste && articleExiste.length > 1)) {
          retour = articleExiste[0];
          break;
        }
      }
      if (retour) {
        this.error = `L\'article ${retour.libelleObjetEntite || ((retour.code ? (retour.code + '/') :
          '') + (retour.libelle || ''))} est spécifié plusieurs fois.`;
        this.step = 4;
        this.showSpinner = false;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    }

    //vérification camion si sygetrack activé
    if (this.isSygetrack && this.planning['chantier'] && this.planning['chantier'].codeExterne &&
      this.planning['chantier'].codeExterne.trim() !== '.') {
      if (!this.planning['machine'] || !this.planning['machine'].id) {
        this.error = 'Sygetrack : veuillez sp\u00e9cifier le matériel.';
        this.showSpinner = false;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    }

    const chauffeurLead = this.param['ecolocEquipe'] ? objetEquipe.chauffeur : (this.planning['chauffeur'] || { id: 0 });
    chauffeurLead.nomclass = 'Chauffeur'

    const program = this.createObjtMvtBennePgm();
    const start = moment(date.setHours((this.planning['hourStart'] || '00'), (this.planning['minStart'] || '00')));
    const end = moment(date.setHours((this.planning['hourEnd'] || '00'), (this.planning['minEnd'] || '00')));
    this.deleteEvent(this.selectedEvent['id']);
    const location = {
      'id': 0,
      'idNouveauObjet': 1, // pour que LocationMateriel1.equals(LocationMateriel2) soientt vrai (réecriture equals)
      'clefBonOrigine': this.planning['clefBonOrigine'] ? this.planning['clefBonOrigine'] : 0,
      'nomclass': 'LocationMateriel',
      'client': {
        'id': this.planning['client'].id,
        'nomclass': 'Client',
        'nomClient': this.planning['client'] ? this.planning['client'].nomClient : ''
      },
      'bon': {
        'isClientDemandeur': this.param['clientDemandeurEcoloc'] ? (this.planning['clientDemandeur'] ? true : false) : false,
        'numBSDManuel': this.planning['numBSDD'] || '',
        'clientDemandeur': {
          'id': this.param['clientDemandeurEcoloc'] ? (this.planning['clientDemandeur'] ?
            this.planning['clientDemandeur'].id : '') : '', // ovaina
          'nomclass': 'Client'
        }
      },
      'chantier': {
        'id': this.planning['chantier'] ? this.planning['chantier'].id : 0,
        'numChantier': this.planning['chantier'] ? this.planning['chantier']['numChantier'] || '' : '',
        'responsable': this.planning['chantier'] ? this.planning['chantier']['responsable'] || '' : '',
        'nomclass': 'Chantier'
      },
      'article': {
        'id': this.planning['multiPrestation'] ? '' : (this.planning['prestation'] ? this.planning['prestation'].id : 0),
        'libelleObjetEntite': this.planning['multiPrestation'] ? '' : (this.planning['prestation']['libelleObjetEntite'] ? this.planning['prestation']['libelleObjetEntite'] : ''),
        'qtePrevisionnelle': this.planning['multiPrestation'] ? '' : (this.planning['qtePrevisionnelle'] || 0.0),
        'nomclass': 'Article'
      },
      'listPrestation': this.planning['multiPrestation'] ? this.planning['listPrestation'] : [],
      'listMateriel': this.planning['listMateriel'] ? this.planning['listMateriel'] : [],
      'camion': {
        'id': (this.planning['machine'] ? this.planning['machine'].id : ''),
        'immatriculation': this.planning['machine'] ? this.planning['machine']['immatriculation'] || '' : '',
        'numParc': this.planning['machine'] ? this.planning['machine']['numParc'] || '' : '',
        'nomclass': 'Camion'
      },
      'chauffeur': chauffeurLead,
      'exutoire': {
        'id': (this.planning['exutoire'] ? this.planning['exutoire'].id : ''), // this.selectedEvent['resourceId'],
        'nom': (this.planning['exutoire'] ? this.planning['exutoire'].libelleObjetEntite : ''),
        'nomclass': 'Exutoire'
      },
      'chauffeurPrestataire': {
        'id': (this.planning['partenaire'] ? this.planning['partenaire'].id : '0'), // this.selectedEvent['resourceId'],
        'nomclass': 'Chauffeur'
      },
      'site': {
        'id': this.isShowSite && this.planning['sitePrest'] ? (this.planning['sitePrest'].id || this.common.user[2]) : this.common.user[2],
        'nom': (this.planning['sitePrest'] ? (this.planning['sitePrest'].nom || this.planning['sitePrest'].libelleObjetEntite) : ''),
        'nomclass': 'SiteEntreprise'
      },
      'siteCA': {
        'id': this.isShowSite && this.planning['siteCA'] ? (this.planning['siteCA'].id || this.common.user[2]) : this.common.user[2],
        'nom': (this.planning['siteCA'] ? (this.planning['siteCA'].nom || this.planning['siteCA'].libelleObjetEntite) : ''),
        'nomclass': 'SiteEntreprise'
      },
      'listePersonnelParPoste': objetEquipe.listePersonnelParPosteMvt,
      'dateDebut': moment(this.planning['dateStart']).format('DD/MM/YYYY'),
      'dateFin': moment(this.planning['dateEnd']).format('DD/MM/YYYY'),
      'heureDebut': start.format('HH:mm:ss'),
      'heureFin': end.format('HH:mm:ss'),
      'infosFact': (this.planning['infofact'] ? this.planning['infofact'] : ''),
      'infosSup': (this.planning['infosupp'] ? this.planning['infosupp'] : ''),
      'rappelActif': this.planning['rappel'] ? (this.planning['rappel'].id !== 0 || this.planning['israppelLibre'] ?
        true : false) : false,
      'rappel': (this.planning['rappel'] ? (this.planning['rappel'].id !== 0 || this.planning['israppelLibre'] ?
        this.planning['rappel'].value : '') : ''),
      'periode': this.planning['periode'] || { id: 0 },
      'rappelLibre': this.planning['israppelLibre'],
      'valeurRappelLibre': this.planning['israppelLibre'] ? this.planning['rappelLibreValeur'] : '',
      'typeRappelLibre': this.planning['israppelLibre'] ? this.planning['rappelLibre'].id : '',
      'isRappelFired': this.planning['rappel'] ? (this.planning['rappel'].id !== 0 || this.planning['israppelLibre'] ?
        false : '') : '',
      'horsProgram': this.planning['program'] ? false : true,
      'dateProgram': moment(this.planning['dateStart']).format('DD/MM/YYYY'),
      'facturation': this.planning['isAcompte'] ? this.planning['acompte'] || 0 : 0,
      'numContrat': this.planning['isContrat'] ? this.planning['numContrat'] || '' : '',
    };
    const copy = Object.assign({}, location);
    location['materielLoue'] = {
      'id': 0,
      listeLocations: [
        copy
      ],
      'listePersonnelParPoste': objetEquipe.listePersonnelParPoste,
      'equipeDefinie': objetEquipe.listePersonnelParPoste && objetEquipe.listePersonnelParPoste.length ? true : false,
      'leaderEquipe': objetEquipe.leaderEquipe || { id: 0 },
      'qualificationLeader': objetEquipe.qualificationLeader,
      'client': {
        'id': this.planning['client'] ? this.planning['client'].id : 0,
      },
      'program': program
    };

    // PanneauLocation.java -> appliquerModificationsLocationsSupplementaires
    let listeLocations = [];
    listeLocations.push(...this.listeLocationsAnnules);
    listeLocations.push(...this.listeLocationsProgrammees);
    listeLocations.push(...this.listeLocationsSupplementaires);
    listeLocations.forEach(eltListeLoc => {
      if (!eltListeLoc['id']) {
        eltListeLoc['client'] = {
          'id': this.planning['client'] ? this.planning['client'].id : 0,
          'nomclass': 'Client'
        };
      }

      eltListeLoc['chantier'] = {
        'id': this.planning['chantier'] ? this.planning['chantier'].id : 0,
        'numChantier': this.planning['chantier'] ? this.planning['chantier']['numChantier'] || '' : '',
        'responsable': this.planning['chantier'] ? this.planning['chantier']['responsable'] || '' : '',
        'nomclass': 'Chantier'
      };
      // eltListeLoc['provenanceCamion'] = this.eventSelected['detail'].provenanceCamion || {};
      // eltListeLoc['destinationCamion'] = this.eventSelected['detail'].destinationCamion || {};
      eltListeLoc['exutoire'] = {
        'id': (this.planning['exutoire'] ? this.planning['exutoire'].id : ''), // this.selectedEvent['resourceId'],
        'nomclass': 'Exutoire'
      };
      eltListeLoc['camion'] = {
        'id': (this.planning['machine'] ? this.planning['machine'].id : ''),
        'immatriculation': this.planning['machine'] ? this.planning['machine']['immatriculation'] || '' : '',
        'numParc': this.planning['machine'] ? this.planning['machine']['numParc'] || '' : '',
        'nomclass': 'Camion'
      };

      if (!this.param['ecolocEquipe']) {
        eltListeLoc['chauffeur'] = chauffeurLead;
      }

      eltListeLoc['article'] = {
        'id': this.planning['prestation'] ? this.planning['prestation'].id : '',
        'libelleObjetEntite': this.planning['multiPrestation'] ? '' : (this.planning['prestation']['libelleObjetEntite'] ? this.planning['prestation']['libelleObjetEntite'] : ''),
        'qtePrevisionnelle': this.planning['multiPrestation'] ? '' : (this.planning['qtePrevisionnelle'] || 0.0),
        'nomclass': 'Article'
      };

      eltListeLoc['listPrestation'] = this.planning['multiPrestation'] ? this.planning['listPrestation'] : [];
      // eltListeLoc['contrat'] = this.eventSelected['detail'].listPrestation || [];

      eltListeLoc['site'] = {
        'id': this.isShowSite && this.planning['sitePrest'] ? (this.planning['sitePrest'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      };

      eltListeLoc['siteCA'] = {
        'id': this.isShowSite && this.planning['siteCA'] ? (this.planning['siteCA'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      };
      eltListeLoc['numContrat'] = this.planning['isContrat'] ? this.planning['numContrat'] || '' : '';
    });

    const materielLoue = {
      'id': 0,
      'listeLocations': [],
      'listePostes': objetEquipe.listePostes || [],
      'listePersonnelParPoste': objetEquipe.listePersonnelParPoste,
      'equipeDefinie': objetEquipe.listePersonnelParPoste && objetEquipe.listePersonnelParPoste.length ? true : false,
      'leaderEquipe': objetEquipe.leaderEquipe || { id: 0 },
      'qualificationLeader': objetEquipe.qualificationLeader,
      'client': {
        'id': this.planning['client'] ? this.planning['client'].id : 0,
      },
      'program': program
    };
    const materielLoueCopy = Object.assign({}, materielLoue);

    listeLocations.forEach(eltListeLoc => {
      eltListeLoc['materielLoue'] = materielLoueCopy;
    });

    listeLocations.unshift(location);
    materielLoue['listeLocations'] = listeLocations;

    const locationMateriel = {
      'id': 0,
      'idNouveauObjet': 1, // pour que LocationMateriel1.equals(LocationMateriel2) soientt vrai (réecriture equals)
      'clefBonOrigine': this.planning['clefBonOrigine'] ? this.planning['clefBonOrigine'] : 0,
      'nomclass': 'LocationMateriel',
      'client': {
        'id': this.planning['client'] ? this.planning['client'].id : 0,
        'nomclass': 'Client',
        'nomClient': this.planning['client'] ? this.planning['client'].nomClient : ''
      },
      'bon': {
        'isClientDemandeur': this.param['clientDemandeurEcoloc'] ? (this.planning['clientDemandeur'] ? true : false)
          : false,
        'numBSDManuel': this.planning['numBSDD'] || '',
        'clientDemandeur': {
          'id': this.param['clientDemandeurEcoloc'] ? (this.planning['clientDemandeur'] ?
            this.planning['clientDemandeur'].id : '') : '', // ovaina
          'nomclass': 'Client'
        }
      },
      'chantier': {
        'id': this.planning['chantier'] ? this.planning['chantier'].id : 0,
        'numChantier': this.planning['chantier'] ? this.planning['chantier']['numChantier'] || '' : '',
        'responsable': this.planning['chantier'] ? this.planning['chantier']['responsable'] || '' : '',
        'nomclass': 'Chantier'
      },
      'article': {
        'id': this.planning['prestation'] ? this.planning['prestation'].id : '',
        'libelleObjetEntite': this.planning['multiPrestation'] ? '' : (this.planning['prestation']['libelleObjetEntite'] ? this.planning['prestation']['libelleObjetEntite'] : ''),
        'qtePrevisionnelle': this.planning['multiPrestation'] ? '' : (this.planning['qtePrevisionnelle'] || 0.0),
        'nomclass': 'Article'
      },
      'listPrestation': this.planning['multiPrestation'] ? this.planning['listPrestation'] : [],
      'listMateriel': this.planning['listMateriel'] ? this.planning['listMateriel'] : [],
      'camion': {
        'id': (this.planning['machine'] ? this.planning['machine'].id : ''),
        'immatriculation': this.planning['machine'] ? this.planning['machine']['immatriculation'] || '' : '',
        'numParc': this.planning['machine'] ? this.planning['machine']['numParc'] || '' : '',
        'nomclass': 'Camion'
      },
      'chauffeur': chauffeurLead,
      'exutoire': {
        'id': (this.planning['exutoire'] ? this.planning['exutoire'].id : ''), // this.selectedEvent['resourceId'],
        'nom': (this.planning['exutoire'] ? this.planning['exutoire'].libelleObjetEntite : ''),
        'nomclass': 'Exutoire'
      },
      'chauffeurPrestataire': {
        'id': (this.planning['partenaire'] ? this.planning['partenaire'].id : '0'), // this.selectedEvent['resourceId'],
        'nomclass': 'Chauffeur'
      },
      'site': {
        'id': this.isShowSite && this.planning['sitePrest'] ? (this.planning['sitePrest'].id || this.common.user[2]) : this.common.user[2],
        'nom': (this.planning['sitePrest'] ? (this.planning['sitePrest'].nom || this.planning['sitePrest'].libelleObjetEntite) : ''),
        'nomclass': 'SiteEntreprise'
      },
      'siteCA': {
        'id': this.isShowSite && this.planning['siteCA'] ? (this.planning['siteCA'].id || this.common.user[2]) : this.common.user[2],
        'nom': (this.planning['siteCA'] ? (this.planning['siteCA'].nom || this.planning['siteCA'].libelleObjetEntite) : ''),
        'nomclass': 'SiteEntreprise'
      },
      'dateDebut': moment(this.planning['dateStart']).format('DD/MM/YYYY'),
      'dateFin': moment(this.planning['dateEnd']).format('DD/MM/YYYY'),
      'heureDebut': start.format('HH:mm:ss'),
      'heureFin': end.format('HH:mm:ss'),
      'infosFact': this.planning['infofact'] ? this.planning['infofact'] : '',
      'infosSup': this.planning['infosupp'] ? this.planning['infosupp'] : '',
      'rappelActif': this.planning['rappel'] ? (this.planning['rappel'].id !== 0 || this.planning['israppelLibre'] ?
        true : false) : false,
      'rappel': (this.planning['rappel'] ? (this.planning['rappel'].id !== 0 || this.planning['israppelLibre'] ?
        this.planning['rappel'].value : '') : ''),
      'periode': this.planning['periode'] || { id: 0 },
      'rappelLibre': this.planning['israppelLibre'],
      'valeurRappelLibre': this.planning['israppelLibre'] ? this.planning['rappelLibreValeur'] : '',
      'typeRappelLibre': this.planning['israppelLibre'] ? this.planning['rappelLibre'].id : '',
      'isRappelFired': this.planning['rappel'] ? (this.planning['rappel'].id !== 0 || this.planning['israppelLibre'] ?
        false : '') : '',
      'horsProgram': this.planning['program'] ? false : true,
      'dateProgram': moment(this.planning['dateStart']).format('DD/MM/YYYY'),
      'listePersonnelParPoste': objetEquipe.listePersonnelParPosteMvt,
      'facturation': this.planning['isAcompte'] ? this.planning['acompte'] || 0 : 0,
      'numContrat': this.planning['isContrat'] ? this.planning['numContrat'] || '' : '',
      'materielLoue': materielLoue
    };

    // console.log(locationMateriel);
    this.corrigerListePersonnelParPoste_plusPrestation(locationMateriel);
    // console.log('DBSaveUpdateLocation', locationMateriel);

    /*
    if(true) { //debug
        this.toogleSlide();
        this.showSpinner = false;        
        return false;
    }
    */

    const param = {
      'servlet': 'DBSaveUpdateLocation',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'LOCATION': locationMateriel,
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        }
      }
    };

    if (this.isDepuisDonneesTechniqueContrat) {
      $('.slide-prestation').trigger('click');
      this.showSpinner = false;
      this.create.emit(locationMateriel);
    } else {
      // $('.slide-prestation').hide();
      this.validerBSDDManContenantVert().then(datasBSD => {
        if (datasBSD.data) {
          this.common.post('', { param: param }).then(datas => {
            $('.slide-prestation').trigger('click');
            if (this.common.verifySession(datas)) {
              if (datas.data !== null) {
                let objPrincipal = datas.data;
                if (!objPrincipal.id && !objPrincipal.bon && datas.data.materielLoue && datas.data.materielLoue.listeLocations) {
                  console.log('Changement objPrincipal');
                  objPrincipal = datas.data.materielLoue.listeLocations[0];
                }

                const codeExterne = this.planning['chantier'].codeExterne;
                const appelerSygetrack = this.isSygetrack && this.planning['chantier'] && codeExterne && codeExterne.trim() !== '.';
                this.getDetail(objPrincipal.id).then(() => {
                  // Envoi sygetrack
                  if (appelerSygetrack) {
                    this.common.openModal(this.modalService, this.loadingSygetrack);
                    GestionSygetrack.setPlannification(this.eventSelected['detail'], true, this.common).then(datas => {
                      if (datas.data && datas.data['erreur']) {
                        this.setMsgSygetrack(datas.data['erreur'])
                        // Pour debug
                        if (datas.data['url']) {
                          console.log('URL SYGETRACK SET_PLANIF ECOLOC (CREATE) : ' + datas.data['url']);
                        }

                        // Revert (supprimer la location créée précédement)
                        GestionSygetrack.rollbackLocationMateriel(this.eventSelected['detail'], this.common).then(datas => {
                          this.reload();
                          this.toogleSlide();
                          this.showSpinner = false;
                        });
                      } else {
                        this.closeSygetrack();
                        this.reload();
                        this.toogleSlide();
                        this.showSpinner = false;
                      }
                    });
                  }
                });

                const numBon = objPrincipal.bon && objPrincipal.bon.numBon || '';

                const msg = 'Vous venez de créer le bon ' + numBon +
                  '.  <span class="text-underline" (click)="getDetailModif(datas.data)"> Cliquez ici pour le modifier </span>';
                this.alert.success(msg);
                this.common.createLog('49', objPrincipal.id, true);
                this.common.createLog('43', objPrincipal.bon.id, true);

                if (!appelerSygetrack) {
                  this.reload();
                  this.toogleSlide();
                  this.showSpinner = false;
                }
              } else {
                if (datas.message) {
                  this.alert.error(datas.message);
                  this.showSpinner = false;
                }
              }
            }
          }).catch(err => {
            console.log(err)
            this.showSpinner = false;
          });
        }
      }).catch(err => {
        console.log(err)
        this.showSpinner = false;
      });
    }
  }

  corrigerListePersonnelParPoste_plusPrestation(locationMateriel) {
    locationMateriel['notSetZeroPosteEquipeOnDeserialize'] = true;
    if (locationMateriel['materielLoue'] && locationMateriel['materielLoue'].listeLocations) {
      locationMateriel['materielLoue'].listeLocations.forEach((locationFille, index) => {
        locationFille['notSetZeroPosteEquipeOnDeserialize'] = true;
        if (index) {
          // console.log(Object.assign([], locationFille));
          const cloneListePersonnelParPosteParent = [];
          // console.log(cloneListePersonnelParPosteParent);
          locationMateriel['materielLoue'].listePersonnelParPoste.forEach(eltPersonnelParPosteParent => {
            const equipe = Object.assign({}, eltPersonnelParPosteParent)
            locationFille['listePersonnelParPoste'] = locationFille['listePersonnelParPoste'] || [];
            const existe = locationFille.listePersonnelParPoste.filter(eltPersonnelParPosteFille =>
              eltPersonnelParPosteFille.poste && eltPersonnelParPosteFille.poste
              && eltPersonnelParPosteParent.poste.id === eltPersonnelParPosteFille.poste.id);
            if (existe && existe.length) {
              const eltPersonnelParPosteFille = existe[0];
              equipe['chauffeur'] = Object.assign({}, eltPersonnelParPosteFille['chauffeur']);
              equipe['chauffeur'].lieuChantier = Object.assign({}, eltPersonnelParPosteFille['lieuChantier'] || { id: 0 });
              equipe['chauffeur'].lieuDepart = Object.assign({}, eltPersonnelParPosteFille['lieuDepart'] || { id: 0 });
            }

            /* Pour les nouvelles locations supplémentaires (plus de prestation) on gère ici les postes qui ont été supprimées
             * Sous l'ancienne interface : 
             * -  on ne fait cela que si c'est une location programmé locationMateriel.materielLoue.program.id>0
             * -  Et sur les locations simple non programmé on garde les postes supprimées sur les location filles
             */
            const posteDejaSupprimee = this.isPosteSupprimee(locationMateriel, eltPersonnelParPosteParent.poste.id);
            if (equipe['chauffeur'] && posteDejaSupprimee && !locationFille.id && locationFille.horsProgram) {
              equipe['chauffeur'].posteSupprime = true;
            }

            cloneListePersonnelParPosteParent.push(equipe);
          });

          locationFille.listePersonnelParPoste = cloneListePersonnelParPosteParent;
        }

      });
      // console.log(locationMateriel['materielLoue'].listeLocations);
    }
  }

  // Pour savoir qu'une poste a déjà été supprimé dans locationMateriel.listePersonnelParPoste
  isPosteSupprimee(locationMateriel, posteIdToFind) {
    let isSupprime = false;
    if (locationMateriel['materielLoue'] && locationMateriel.listePersonnelParPoste) {
      locationMateriel.listePersonnelParPoste.forEach(posteEquipe => {
        if (posteEquipe.poste && posteEquipe.poste.id === posteIdToFind && posteEquipe.chauffeur && posteEquipe.chauffeur.posteSupprime) {
          isSupprime = true;
        }
      });
    }

    return isSupprime;
  }

  toogleSlide() {
    this.closefct.emit();
  }

  reload() {
    this.rafraichir.emit();
  }

  selectDate($event, id) {

    this.common.focusElement(id);
  }

  getFormatperso() {
    const param = {
      'servlet': 'DBGestionFormatParametrable',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_TYPE_FORMAT': {
          'typeParam': 'int',
          'valeur': 15
        },
        'LES_DEUX_LISTES': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.formatPerso = datas.data;
      if (this.formatPerso.length > 1) {
        this.formatprs = this.formatPerso[0];
        // open modal
        this.common.openModal(this.modalService, this.format);
      } else {
        // get pdf to print
        if (this.formatPerso.length === 1) {
          this.formatprs = this.formatPerso[0];
          this.initImprimerBon();
        } else {
          this.common.openModal(this.modalService, this.format);
        }
      }
    });
  }

  openSupprModal() {
    if (this.dataMotifSuppression && this.dataMotifSuppression.length) {
      this.planning.motifSuppression = this.dataMotifSuppression[0];
    }
    this.common.openModal(this.modalService, this.template);
  }

  initImprimerBon() {
    if (!this.eventSelected['detail'].chauffeur || !this.eventSelected['detail'].chauffeur.id) {
      this.common.closeModal();
      this.common.openModal(this.modalService, this.confirmeImpBonSansLeader);
    } else {
      this.imprimerBon();
    }
  }

  imprimerBon() {
    this.eventSelected['detail'].nomclass = 'LocationMateriel';
    const param = {
      'servlet': 'DBImprimerBonLocation',
      'module': 'Ecoloc',
      'type': 'liste',
      'compression': 'false',
      'pathImpression': 'Ecoloc/tmp/BonEcoloc/',
      'data': [
        this.eventSelected['detail'],
        '',
        {
          'typeParam': 'int',
          'valeur': this.formatprs['id']
        },
        'null',
        'null',
        'null',
        {
          'typeParam': 'int',
          'valeur': 0
        },
        {
          'typeParam': 'int',
          'valeur': 0
        },
        {
          'typeParam': 'int',
          'valeur': 0
        },
        'null',
        '' + this.common.user[2],
        {
          'typeParam': 'int',
          'valeur': 0
        },
        {
          'typeParam': 'int',
          'valeur': 0
        },
      ]
    };
    this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.length) {
        this.common.openFile(datas.data[0]);
        this.common.closeModal();
        this.formatprs = '';
      } else {
        if (datas.message) {
          this.common.closeModal();
          this.alert.error(datas.message);
          this.reinit();
        }
      }
    });
  }

  reinit() {
    this.showSpinner = false;
    this.reinitfct.emit();
  }


  getDetail(id) {
    const user = this.common.local.getObject('userInfo');
    const param = {
      'servlet': 'DBGetListLocationMateriel',
      'module': 'Ecoloc',
      'type': 'liste',
      'compression': 'true',
      'data': [
        '',
        '',
        '0',
        '0',
        'false',
        'false',
        {
          'typeParam': 'int',
          'valeur': user[2]
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        {
          'typeParam': 'int',
          'valeur': user[0]
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        {
          'typeParam': 'int',
          'valeur': id || 0 // id location
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        {
          'typeParam': 'int',
          'valeur': '0'
        },
        'false', // index 17
        'true' // index 18 pour le point 167963
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      $('.slide-prestation').trigger('click');
      if (this.common.verifySession(datas)) {
        this.eventSelected['detail'] = datas.data ? datas.data[0] : {};
        this.eventSelected['start'] = datas.data ? this.common.parseDate(datas.data[0].dateDebut) : '';
      }
    });
  }

  deleteBon(motif) {
    this.eventSelected['detail'].nomclass = 'LocationMateriel';
    this.eventSelected['detail'].motifAnnulation = motif;
    if (this.dataMotifSuppression && this.dataMotifSuppression.length) {
      this.eventSelected['detail'].motifSuppressionEcoloc = this.planning['motifSuppression'] && this.planning['motifSuppression'].id ? this.planning['motifSuppression'] : { id: 0 };
    }
    this.showSpinner = false;
    const param = {
      'servlet': 'DBDeleteLocation',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'LOCATION': this.eventSelected['detail'],
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        }
      }
    };
    // $('.slide-prestation').hide();
    this.common.post('', { param: param }).then(datas => {
      $('.slide-prestation').trigger('click');
      if (datas.data !== null) {
        // supprimer la location sygetrack
        const oLocationMateriel = this.eventSelected['detail']; // La location matériel à supprimer
        const codeExterne = oLocationMateriel.chantier.codeExterne;
        const appelerSygetrack = this.isSygetrack && oLocationMateriel &&
          oLocationMateriel.chantier && codeExterne && codeExterne.trim() !== '.';
        if (appelerSygetrack) {
          this.common.openModal(this.modalService, this.loadingSygetrack);
          GestionSygetrack.delPlannification(oLocationMateriel.bon.numBon, oLocationMateriel.id, this.common).then(datas => {
            if (datas.data && datas.data['erreur']) {
              this.setMsgSygetrack(datas.data['erreur'])

              // Pour debug
              if (datas.data['url']) {
                console.log('URL SYGETRACK DEL_PLANIF ECOLOC (UPDATE) : ' + datas.data['url']);
              }
            } else {
              this.closeSygetrack();
            }
          });
        }

        this.reload();
        this.showSpinner = false;
        this.toogleSlide();
      }
    }).catch(err => this.showSpinner = false);
    this.common.closeModal();
  }


  confirmDeleteBon() {
    if (this.dataMotifSuppression && this.dataMotifSuppression.length) {
      this.planning['motifannulation'] = this.planning['motifSuppression'] && this.planning['motifSuppression'].id && !this.planning['motifannulation'] ? (this.planning['motifSuppression'].libelle || this.planning['motifSuppression'].libelleObjetEntite) : this.planning['motifannulation'];
    }
    if (this.planning['motifannulation']) {
      this.deleteBon(this.planning['motifannulation']);
    } else {
      this.error = "Le motif de la suppression est obligatoire ."
      this.common.openModal(this.modalService, this.msg);
    }
  }

  verifierSiExistePrestDatePosterieur(location) {
    const qual = {
      'servlet': 'DBGestionMaterielLoue',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 11
        },'LOCATION_MATERIEL' :location
      }
    };
      this.common.post('', { param: qual }).then(datas => {
      if (this.common.verifySession(datas)) {
        const isProgramme = location.materielLoue && location.materielLoue.program && location.materielLoue.program.id ? true : false;
        const isMaterielLoue = location.materielLoue && location.materielLoue.id ? true : false;
         if(datas.data && datas.data.length && isProgramme  && isMaterielLoue) {
            this.common.openModal(this.modalService,this.confirmePrestPostprogramme);
             return false;
         } else {
          return  this.updateBon(true);
         }
      }
    }).catch((err)=>{
      this.showSpinner = false;
    })
  }

  acceptSupPrestPostprogramme() {
    const locationMateriel = this.createObjetLocationMateriel();
    const qual = {
      'servlet': 'DBGestionMaterielLoue',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 12
        },'LOCATION_MATERIEL' :locationMateriel
      }
    };
    return this.common.post('', { param: qual }).then(datas => {
        this.updateBon(true)
    }).catch((err)=>{
      this.showSpinner = false;
    })
  }

  refuseSupPrestPostprogramme() {
    this.updateBon(true)
  }


  createObjetLocationMateriel() {
    const program = this.createObjtMvtBennePgm();
    this.showSpinner = true;
    // const qual = {
    //   'servlet': 'DBGestionQualificationPersonnel',
    //   'module': 'Recylog',
    //   'type': 'map',
    //   'compression': 'false',
    //   'data': {
    //     'OPERATION': {
    //       'typeParam': 'int',
    //       'valeur': '2'
    //     }
    //   }
    // };

    if (this.eventSelected['detail'].listPrestation) {
      this.eventSelected['detail'].listPrestation.forEach(elt => elt.nomclass = 'Article');
    }

    // return this.common.post('', { param: qual }).then(element => {
    $('.slide-prestation').trigger('click');
    this.showSpinner = true;
    const objetEquipe = this.objMvtEquipe();
    const equipe = objetEquipe.listePersonnelParPosteMvt || [];
    const equipeMat = objetEquipe.listePersonnelParPoste || [];

    // console.log(objetEquipe);

    // this.eventSelected['detail'].listePersonnelParPoste.forEach(elt => {
    //   equipe.push({
    //     chauffeur: {
    //       id: elt.chauffeur ? elt.chauffeur.id : 0,
    //       'nomclass': 'Chauffeur'
    //     },
    //     poste: {
    //       id: elt.poste ? elt.poste.id : 0,
    //       qualification: {
    //         id: element.data[0].id,
    //         'nomclass': 'QualificationPersonnel'
    //       }
    //     }
    //   });
    //   equipeMat.push({
    //     id: 0,
    //     qualification: {
    //       id: element.data[0].id,
    //       'nomclass': 'QualificationPersonnel'
    //     }
    //   });
    // });

    const idMaterielLou = this.eventSelected['detail'] && this.eventSelected['detail'].materielLoue ?
      (this.eventSelected['detail'].materielLoue.id || 0) : 0;
    // console.log(idMaterielLou, this.eventSelected['detail']);
    const chauffeur = this.param['ecolocEquipe'] ? (objetEquipe.chauffeur || { id: 0 })
      : (this.eventSelected['detail'].chauffeur || { id: 0 });
    chauffeur.nomclass = 'Chauffeur'

    const location = {
      'id': this.eventSelected['detail'].id,
      'nomclass': 'LocationMateriel',
      'client': {
        'id': this.eventSelected['detail'].client.id,
        'nomclass': 'Client'
      },
      'bon': {
        'id': this.eventSelected['detail'].bon.id,
        'isClientDemandeur': this.eventSelected['detail'].bon.clientDemandeur ? true
          : (this.planning['showInfos'] ? true : false),
        'numBSDManuel': this.planning['numBSDD'] || '',
        'clientDemandeur': {
          'id': this.eventSelected['detail'].bon.clientDemandeur ? this.eventSelected['detail'].bon.clientDemandeur.id :
            (this.planning['clientDemandeur'] ? this.planning['clientDemandeur'].id : ''), // ovaina
          'nomclass': 'Client'
        }
      },
      'chantier': {
        'id': this.eventSelected['detail'].chantier.id,
        'numChantier': this.eventSelected['detail']['chantier'] ? this.eventSelected['detail']['chantier']['numChantier'] || '' : '',
        'responsable': this.eventSelected['detail']['chantier'] ? this.eventSelected['detail']['chantier']['responsable'] || '' : '',
        'nomclass': 'Chantier'
      },
      'article': {
        'id': this.eventSelected['detail'].article ? this.eventSelected['detail'].article.id : '',
        'libelleObjetEntite': this.eventSelected['detail']['multiPrestation'] || (!this.eventSelected['detail'].article || (this.eventSelected['detail'].article && !this.eventSelected['detail'].article.id)) ? '' :
          (this.eventSelected['detail'].article['libelleObjetEntite'] ? this.eventSelected['detail'].article['libelleObjetEntite'] : ''),
        'qtePrevisionnelle': this.eventSelected['detail'].article && this.eventSelected['detail'].article.qtePrevisionnelle ?
          this.eventSelected['detail'].article.qtePrevisionnelle : 0.0,
        'nomclass': 'Article'
      },
      'listPrestation': this.eventSelected['detail'].listPrestation || [],
      'listMateriel': this.eventSelected['detail'].listMateriel || [],
      'camion': {
        'id': (this.eventSelected['detail'].camion ? this.eventSelected['detail'].camion.id : ''),
        'immatriculation': this.eventSelected['detail']['camion'] ? this.eventSelected['detail']['camion']['libelleEdit'] || '' : '',
        'nomclass': 'Camion'
      },
      'chauffeur': chauffeur,
      'exutoire': {
        'id': (this.planning['exutoire'] ? this.planning['exutoire'].id : ''), // this.selectedEvent['resourceId'],
        'nomclass': 'Exutoire'
      },
      'chauffeurPrestataire': {
        'id': (this.planning['partenaire'] ? this.planning['partenaire'].id : '0'), // this.selectedEvent['resourceId'],
        'nomclass': 'Chauffeur'
      },
      'site': {
        'id': this.isShowSite && this.planning['sitePrest'] ? (this.planning['sitePrest'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      },
      'siteCA': {
        'id': this.isShowSite && this.planning['siteCA'] ? (this.planning['siteCA'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      },
      'listePersonnelParPoste': equipe,
      'dateDebut': this.eventSelected['detail'].dateDebut,
      'dateFin': this.eventSelected['detail'].dateFin,
      'heureDebut': this.eventSelected['detail'].heureDebut,
      'heureFin': this.eventSelected['detail'].heureFin,
      'infosFact': this.eventSelected['detail'].infosFact,
      'infosSup': this.eventSelected['detail'].infosSup,
      'rappelActif': this.eventSelected['detail'].rappelActif,
      'rappel': this.eventSelected['detail'].rappel,
      'periode': this.eventSelected['detail'].periode,
      'rappelLibre': this.eventSelected['detail'].rappelLibre,
      'valeurRappelLibre': this.eventSelected['detail'].rappelLibre ? this.eventSelected['detail'].valeurRappelLibre : '',
      'typeRappelLibre': this.eventSelected['detail'].rappelLibre ? this.eventSelected['detail'].typeRappelLibre : '',
      'isRappelFired': this.eventSelected['detail'].rappel ? false : '',
      'horsProgram': this.planning['program'] ? false : true,
      'facturation': this.planning['isAcompte'] ? this.planning['acompte'] || 0 : 0,
      'numContrat': this.planning['isContrat'] ? this.planning['numContrat'] || '' : '',
    };

    if (this.eventSelected['detail'].dateProgram) {
      location['dateProgram'] = moment(this.eventSelected['detail'].dateProgram, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
    }

    if (this.isDepuisDonneesTechniqueContrat && this.eventSelected['detail'].locationCorespondante) {
      location['locationCorespondante'] = this.eventSelected['detail'].locationCorespondante;
    }

    const copy = Object.assign({}, location);
    location['materielLoue'] = {
      'id': idMaterielLou,
      listeLocations: [
        copy
      ],
      'listePersonnelParPoste': equipeMat,
      'equipeDefinie': equipe.length ? true : false,
      'leaderEquipe': objetEquipe.leaderEquipe || { id: 0 },
      'qualificationLeader': objetEquipe.qualificationLeader ? objetEquipe.qualificationLeader || { id: 0 } : { id: 0 },
      'client': {
        'id': this.eventSelected['detail'].client.id,
        'nomclass': 'Client'
      },
      'program': program
    };

    // PanneauLocation.java -> appliquerModificationsLocationsSupplementaires
    let listeLocations = [];
    listeLocations.push(...this.listeLocationsAnnules);
    this.listeLocationsProgrammees.forEach(prest => {
      prest['horsProgram'] = false;
    });
    if (this.updateAll)
      listeLocations.push(...this.listeLocationsProgrammees);
    this.listeLocationsSupplementaires.forEach(prest => {
      prest['horsProgram'] = true;
    });
    listeLocations.push(...this.listeLocationsSupplementaires);
    listeLocations.forEach(eltListeLoc => {
      if (!eltListeLoc['id']) {
        eltListeLoc['client'] = {
          'id': this.eventSelected['detail'].client.id,
          'nomclass': 'Client'
        };
      }

      eltListeLoc['chantier'] = this.eventSelected['detail'].chantier || {};
      eltListeLoc['provenanceCamion'] = this.eventSelected['detail'].provenanceCamion || {};
      eltListeLoc['destinationCamion'] = this.eventSelected['detail'].destinationCamion || {};
      eltListeLoc['exutoire'] = {
        'id': (this.planning['exutoire'] ? this.planning['exutoire'].id : ''), // this.selectedEvent['resourceId'],
        'nomclass': 'Exutoire'
      };
      eltListeLoc['camion'] = {
        'id': (this.eventSelected['detail'].camion ? this.eventSelected['detail'].camion.id : ''),
        'nomclass': 'Camion'
      };

      if (!this.param['ecolocEquipe']) {
        eltListeLoc['chauffeur'] = chauffeur;
      }

      eltListeLoc['article'] = {
        'id': this.eventSelected['detail'].article ? this.eventSelected['detail'].article.id : '',
        'qtePrevisionnelle': this.eventSelected['detail'].article && this.eventSelected['detail'].article.qtePrevisionnelle ?
          this.eventSelected['detail'].article.qtePrevisionnelle : 0.0,
        'nomclass': 'Article'
      };

      eltListeLoc['listPrestation'] = this.eventSelected['detail'].listPrestation || [];
      // eltListeLoc['contrat'] = this.eventSelected['detail'].listPrestation || [];

      eltListeLoc['site'] = {
        'id': this.isShowSite && this.planning['sitePrest'] ? (this.planning['sitePrest'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      };

      eltListeLoc['siteCA'] = {
        'id': this.isShowSite && this.planning['siteCA'] ? (this.planning['siteCA'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      };
      eltListeLoc['numContrat'] = this.planning['isContrat'] ? this.planning['numContrat'] || '' : '';
    });
    if (!this.updateAll)
      listeLocations.push(...this.listeLocationsProgrammees);
    listeLocations.unshift(location);

    const locationMateriel = {
      'id': this.eventSelected['detail'].id,
      'nomclass': 'LocationMateriel',
      'client': {
        'id': this.eventSelected['detail'].client.id,
        'nomclass': 'Client'
      },
      'bon': {
        'id': this.eventSelected['detail'].bon.id,
        'isClientDemandeur': this.eventSelected['detail'].bon.clientDemandeur ? true :
          (this.planning['showInfos'] ? true : false),
        'numBSDManuel': this.planning['numBSDD'] || '',
        'clientDemandeur': {
          'id': this.eventSelected['detail'].bon.clientDemandeur ? this.eventSelected['detail'].bon.clientDemandeur.id :
            (this.planning['clientDemandeur'] ? this.planning['clientDemandeur'].id : ''), // ovaina
          'nomclass': 'Client'
        }
      },
      'chantier': {
        'id': this.eventSelected['detail'].chantier.id,
        'numChantier': this.eventSelected['detail']['chantier'] ? this.eventSelected['detail']['chantier']['numChantier'] || '' : '',
        'responsable': this.eventSelected['detail']['chantier'] ? this.eventSelected['detail']['chantier']['responsable'] || '' : '',
        'nomclass': 'Chantier'
      },
      'article': {
        'id': this.eventSelected['detail'].article ? this.eventSelected['detail'].article.id : '',
        'libelleObjetEntite': this.eventSelected['detail']['multiPrestation'] ? '' :
          (this.eventSelected['detail'].article['libelleObjetEntite'] ? this.eventSelected['detail'].article['libelleObjetEntite'] : ''),
        'qtePrevisionnelle': this.eventSelected['detail'].article && this.eventSelected['detail'].article.qtePrevisionnelle ?
          this.eventSelected['detail'].article.qtePrevisionnelle : 0.0,
        'nomclass': 'Article'
      },
      'listPrestation': this.eventSelected['detail'].listPrestation || [],
      'listMateriel': this.eventSelected['detail'].listMateriel || [],
      'camion': {
        'id': (this.eventSelected['detail'].camion ? this.eventSelected['detail'].camion.id : ''),
        'immatriculation': this.eventSelected['detail']['camion'] ? this.eventSelected['detail']['camion']['libelleEdit'] || '' : '',
        'nomclass': 'Camion'
      },
      'chauffeur': chauffeur,
      'exutoire': {
        'id': (this.planning['exutoire'] ? this.planning['exutoire'].id : ''), // this.selectedEvent['resourceId'],
        'nomclass': 'Exutoire'
      },
      'chauffeurPrestataire': {
        'id': (this.planning['partenaire'] ? this.planning['partenaire'].id : '0'), // this.selectedEvent['resourceId'],
        'nomclass': 'Chauffeur'
      },
      'site': {
        'id': this.isShowSite && this.planning['sitePrest'] ? (this.planning['sitePrest'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      },
      'siteCA': {
        'id': this.isShowSite && this.planning['siteCA'] ? (this.planning['siteCA'].id || this.common.user[2]) : this.common.user[2],
        'nomclass': 'SiteEntreprise'
      },
      'contrat': {
        'id': (this.eventSelected['detail'].contrat ? this.eventSelected['detail'].contrat.id : '0'),
        'nomclass': 'Contrat'
      },
      'dateDebut': this.eventSelected['detail'].dateDebut,
      'dateFin': this.eventSelected['detail'].dateFin,
      'heureDebut': this.eventSelected['detail'].heureDebut,
      'heureFin': this.eventSelected['detail'].heureFin,
      'infosFact': this.eventSelected['detail'].infosFact,
      'infosSup': this.eventSelected['detail'].infosSup,
      'rappelActif': this.eventSelected['detail'].rappelActif,
      'rappel': this.eventSelected['detail'].rappel,
      'periode': this.eventSelected['detail'].periode,
      'rappelLibre': this.eventSelected['detail'].rappelLibre,
      'valeurRappelLibre': this.eventSelected['detail'].rappelLibre ? this.eventSelected['detail'].valeurRappelLibre : '',
      'typeRappelLibre': this.eventSelected['detail'].rappelLibre ? this.eventSelected['detail'].typeRappelLibre : '',
      'isRappelFired': this.eventSelected['detail'].rappel ? false : '',
      'horsProgram': this.planning['program'] ? false : true,
      'facturation': this.planning['isAcompte'] ? this.planning['acompte'] || 0 : 0,
      'numContrat': this.planning['isContrat'] ? this.planning['numContrat'] || '' : '',
      'listePersonnelParPoste': equipe,
      'materielLoue': {
        'id': idMaterielLou,
        listeLocations: listeLocations,
        'listePersonnelParPoste': equipeMat,
        'equipeDefinie': equipeMat.length ? true : false,
        'listePostes': objetEquipe.listePostes || [],
        'leaderEquipe': objetEquipe.leaderEquipe || { id: 0 },
        'qualificationLeader': objetEquipe.qualificationLeader ? objetEquipe.qualificationLeader || { id: 0 } : { id: 0 },
        'client': {
          'id': this.eventSelected['detail'].client.id,
          'nomclass': 'Client'
        },
        'program': program
      }
    };

    if (this.eventSelected['detail'].dateProgram) {
      locationMateriel['dateProgram'] = moment(this.eventSelected['detail'].dateProgram, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
    }

    if (this.isDepuisDonneesTechniqueContrat && this.eventSelected['detail'].locationCorespondante) {
      locationMateriel['locationCorespondante'] = this.eventSelected['detail'].locationCorespondante;
    }
    return locationMateriel;
  }

  updateBon(firstVerif?) {
    let locationMateriel = this.createObjetLocationMateriel();
    this.corrigerListePersonnelParPoste_plusPrestation(locationMateriel);
    const isExisteDateFin = locationMateriel.materielLoue && locationMateriel.materielLoue.program && locationMateriel.materielLoue.program['dateFin'] ? true : false;
    if(!firstVerif && isExisteDateFin && this.moduleSource == "ecoloc") {
      this.verifierSiExistePrestDatePosterieur(locationMateriel);
      return false
    }
    const dataDBUpdateLocation = {
      'LOCATION': locationMateriel,
      'CLEF_USER': {
        'typeParam': 'int',
        'valeur': this.common.user[0]
      },
      'MODIF_TOUTE_LOCATION_PROGRAMMEE': {
        'typeParam': 'boolean',
        'valeur': this.updateAll ? true : false
      },
      'UPDATE_CHANTIER': {
        'typeParam': 'boolean',
        'valeur': '0'
      }
    };

    const param = {
      'servlet': 'DBUpdateLocation',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': dataDBUpdateLocation
    };

    // if (this.updateAll) {
    //   param.data['LOCATION']['materielLoue']['listePostes'] = param.data['LOCATION']['materielLoue']['listePostes'] || [];
    //   param.data['LOCATION']['materielLoue']['listePostes'].forEach(poste => {
    //     if (poste.posteSuprimeMaintenant) {
    //       poste.posteDesactiveParDefault  = true;
    //     }
    //   })
    // }

    if (this.isDepuisDonneesTechniqueContrat) {
      $('.slide-prestation').trigger('click');
      this.showSpinner = false;
      if ('indexRepereTab' in this.planning) {
        locationMateriel['indexRepereTab'] = this.planning['indexRepereTab'];
      }
      this.updateFct.emit(locationMateriel);
    } else {
      this.validerBSDDManContenantVert().then(datasBSD => {
        if (datasBSD.data) {
          this.common.post('', { param: param }).then(datas => {
            // console.log('data1724', datas)
            $('.slide-prestation').hide();
            $('.slide-prestation').trigger('click');
            if (this.common.verifySession(datas)) {
              this.common.createLog('49', this.eventSelected['detail'].id, false);
              this.common.createLog('43', this.eventSelected['detail'].bon.id, false);
              if (datas.data !== null) {
                this.reload();
                this.toogleSlide();
                // this.reinit();

                // Envoi sygetrack
                const codeExterne = this.eventSelected['detail'].chantier.codeExterne;
                if (this.isSygetrack && this.eventSelected['detail'].chantier && codeExterne && codeExterne.trim() !== '.') {
                  this.common.openModal(this.modalService, this.loadingSygetrack);

                  let sygetrack_camion_immatricule = '';
                  if (this.eventSelected['detail'].camion) {
                    const camion = this.eventSelected['detail'].camion;
                    sygetrack_camion_immatricule = camion.numParc ? camion.numParc + '%2F' + camion.immatriculation : camion.immatriculation;
                  }

                  // si le camion n'a pas été saisie auparavant
                  if (!sygetrack_camion_immatricule && this.planning['machine']) {
                    this.eventSelected['detail'].camion = this.planning['machine'];
                  }

                  GestionSygetrack.setPlannification(this.eventSelected['detail'], false, this.common).then(datas => {
                    if (datas.data && datas.data['erreur']) {
                      this.setMsgSygetrack(datas.data['erreur'])

                      // Pour debug
                      if (datas.data['url']) {
                        console.log('URL SYGETRACK SET_PLANIF ECOLOC (UPDATE) : ' + datas.data['url']);
                      }
                    } else {
                      this.closeSygetrack();
                    }
                  });
                }
              } else {
                if (datas.message) {
                  this.alert.error(datas.message);
                  this.showSpinner = false;
                }
              }
            }
          }).catch(err => {
            console.log(err)
            this.showSpinner = false;
          });
        }
      }).catch(err => {
        console.log(err)
        this.showSpinner = false;
      });

      // }).catch(err => this.showSpinner = false);
    }
  }

  // Recopier locationMateriel.materielLoue.listeLocation[i].materielLoue.listePersonnelParPoste et listePostes vers locationMateriel.materielLoue
  // La locationMateriel et ses listeLocation ont un même clefMaterielLoue
  // GestionPrestationServer.java 2135
  /*
  traiterEquipeListeLocation(locationMateriel) {
      if(locationMateriel.materielLoue.listeLocations.length > 1) {
          // locationMateriel.materielLoue.listeLocations[0] contient le locationMateriel lui même
          for(let i=1; i<locationMateriel.materielLoue.listeLocations.length; i++) {
              let eltListeLocations = locationMateriel.materielLoue.listeLocations[i];
              eltListeLocations.materielLoue = locationMateriel.materielLoue;
              
              
              
              if(eltListeLocations['materielLoue'] && eltListeLocations['materielLoue'].equipeDefinie) {
                  if(eltListeLocations['materielLoue'].listePersonnelParPoste) {
                    eltListeLocations['materielLoue'].listePersonnelParPoste.forEach(p1 => {
                        if(!this.isPersonnelParPosteDansLaListe(p1, locationMateriel.materielLoue.listePersonnelParPoste)) {
                            locationMateriel.materielLoue.listePersonnelParPoste.push(p1);
                        }
                    });
                  }
                  
                  if(eltListeLocations['materielLoue'].listePostes) {
                    eltListeLocations['materielLoue'].listePostes.forEach(p1 => {
                        if(!this.isPosteDansLaListe(p1, locationMateriel.materielLoue.listePostes)) {
                            locationMateriel.materielLoue.listePostes.push(p1);
                        }
                    });
                  }                  
              }
          }
      }
  }
  
  isPersonnelParPosteDansLaListe(p1, listePersonnelParPoste) {
      let ret = false;
      if(p1 && listePersonnelParPoste.length) {
          listePersonnelParPoste.forEach(p2 => {
              if(this.isEqualsPersonnelParPoste(p1, p2)) {
                  ret = true;
              }
          });
      }
      
      return ret;
  }
  
  isPosteDansLaListe(p1, listePoste) {
      let ret = false;
      if(p1 && listePoste.length) {
          listePoste.forEach(p2 => {
              if(this.isEqualsPoste(p1, p2)) {
                  ret = true;
              }
          });
      }
      
      return ret;
  }
  
  isEqualsPersonnelParPoste(p1, p2) {
      return p1.id === p2.id && p1.poste.id === p2.poste.id && 
          p1.chauffeur.id === p1.chauffeur.id;
  }
  
  isEqualsPoste(p1, p2) {
      return p1.id === p2.id && p1.qualification.id === p2.qualification.id;
  }
  */

  validerUpdate() {
    const article = this.eventSelected['detail'] && this.eventSelected['detail'].article
      && this.eventSelected['detail'].article.id ? true : false;
    const articleGroupe = this.eventSelected['detail'] && this.eventSelected['detail'].listPrestation
      && this.eventSelected['detail'].listPrestation.length ? true : false;
    if (!article && !articleGroupe) {
      this.error = 'Veuillez sp\u00e9cifier la prestation.';
      this.step = 4;
      this.common.openModal(this.modalService, this.msg);
      return false;
    }

    if (articleGroupe) {
      const listArticle = this.eventSelected['detail'].listPrestation || [];
      const tousIdZero = listArticle.every(elt => elt.id === 0);
      if (tousIdZero) {
        this.error = 'Il faut choisir au moins un aticle ';
        this.step = 4;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
      let retour;
      for (let i = 0; i < listArticle.length; i++) {
        const obj = listArticle[i];
        const articleExiste = listArticle.filter(elt => elt.id === obj.id);
        if ((articleExiste && articleExiste.length > 1)) {
          retour = articleExiste[0];
          break;
        }
      }

      if (retour) {
        this.error = `L\'article ${retour.libelleObjetEntite || ((retour.code ? (retour.code + '/') :
          '') + (retour.libelle || ''))} est spécifié plusieurs fois.`;
        this.step = 4;
        this.showSpinner = false;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    }

    //vérification camion si sygetrack activé
    if (this.isSygetrack && this.eventSelected['detail'].chantier && this.eventSelected['detail'].chantier.codeExterne &&
      this.eventSelected['detail'].chantier.codeExterne.trim() !== '.') {
      if (!this.eventSelected['detail'].camion || !this.eventSelected['detail'].camion.id) {
        this.error = 'Sygetrack : veuillez sp\u00e9cifier le matériel.';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    }

    const date = (moment(this.planning['date'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
    const dateStart = (moment(this.planning['dateStart'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
    if (this.param['isMotifReportModifMouvement'] && date !== dateStart) {
      this.common.openModal(this.modalService, this.changedate);
    } else {
      this.updateBon();
    }
  }

  update() {
    if (this.raisonReport !== '') {
      this.common.closeModal();
      const date = (moment(this.planning['date'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const dateStart = (moment(this.planning['dateStart'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const param = {
        'servlet': 'DBGestionReportBon',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': '1'
          },
          'REPORT_BON': {
            motifReport: this.raisonReport || '',
            dateBonApresReport: dateStart,
            dateBonAvantReport: date,
            bon: {
              id: this.eventSelected['detail'] && this.eventSelected['detail'].bon ? this.eventSelected['detail'].bon.id || 0 : 0
            },
            user: {
              id: this.common.user[0]
            },
            nomclass: 'ReportBon'
          }
        }
      };
      this.showSpinner = true
      this.common.post('', { param: param }).then(datas => {
        this.updateBon(true);
        // $('.slide-prestation').hide();
      }).catch(err => this.showSpinner = false);
    } else {
      this.error = 'Le champ "Raison report" est obligatoire.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  searchClientNew(event) {
    const user = this.common.local.getObject('userDetail') || {};
    this.common.getModule();
    const activedModule = '' + this.common.activedModule;
    const fonctionUser = user.fonctionUser ? (user.fonctionUser.id || 0) : 0;
    const param = {
      'critere': event,
      'type': ['clients'],
      'afficherCodeNomClient': 'true',
      'afficherPrenom': true,
      'afficherClientToutProspect': 'false',
      'afficherFactureAvoirNonHistorise': 'false',
      'clefSite': this.common.user[2],
      'clefUser': this.common.user[0],
      'clefFonction': fonctionUser,
      'clefModule': activedModule
    };

    this.common.searchEcoloc({ param: param }).then(datas => {
      $('.autoClt').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataClient = datas.data;
      }
    });
  }

  searchClient(event) {
    this.searchClientNew(event);
  }

  searchArticle(event) {
    const param = 4;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      $('.autoPresta').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataArticle = datas.data;
      }
    });
  }

  searchExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      if (this.common.verifySession(datas)) {
        this.dataExutoire = datas.data;
      }
    });
  }

  searchCamion(event) {
    const datestart = this.isEdit ? this.eventSelected['detail'].dateDebut :
      moment(this.common.parseDate(this.planning['dateStart'])).format('DD/MM/YYYY');
    const dateend = this.isEdit ? this.eventSelected['detail'].dateFin :
      moment(this.common.parseDate(this.planning['dateEnd'])).format('DD/MM/YYYY');
    const param = {
      'servlet': 'DBGetListCamion',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'TOUS_CAMIONS': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CAMIONS_CEDES': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRE_RECEPTION_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_RECEPTION_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'AU_GARAGE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'TO_STRING_AVEC_NUM_PARC': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': datestart
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': dateend
        },
        'VISIBLE_ECODECHET': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'CRITERE': event,
        'IS_CAMION_MULTIBENNE_ECOLOC': {
          'typeParam': 'boolean',
          'valeur': this.param['isCamionMultiBenneEcoloc'] || false
        },
        'GET_ONLY_SITE_USER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('.autoMat').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data = datas.data || [];
        datas.data.forEach(elt => {
          const l = (elt.numParc ? elt.numParc + ' / ' : '') + (elt.immatriculation ? elt.immatriculation : '');
          elt.libelleObjetEntite = l;
        });
        this.dataCamion = datas.data;
      }
    });
  }

  searchChauff(event) {
    const datestart = this.isEdit ? this.eventSelected['detail'].dateDebut :
      moment(this.common.parseDate(this.planning['dateStart'])).format('DD/MM/YYYY');
    const dateend = this.isEdit ? this.eventSelected['detail'].dateFin :
      moment(this.common.parseDate(this.planning['dateEnd'])).format('DD/MM/YYYY');
    const param = {
      'servlet': 'DBGestionMaterielLoue',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_LOCATION_MATERIEL': {
          'typeParam': 'int',
          'valeur': this.isEdit ? this.eventSelected['detail'].id : '0'
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': datestart
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': dateend
        },
        'CRITERE': event || '',
        'CLEF_QUALIF_PERSONEL': {
          'typeParam': 'int',
          'valeur': '0'
        },
        'FILTRER_VISIBLE_PLANNING': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_CONTRAT_PERSO': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_AYANT_PRESTATION': {
          'typeParam': 'boolean',
          'valeur': this.common.local.getObject('paramSociete').equipier1PrestationParJour ? true : false
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('.autoPrs').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`);
        this.dataChauffeur = datas.data;
      }
    });
  }

  searchChauffeurEcolocEquipeFalse(event) {
    const datestart = this.isEdit ? this.eventSelected['detail'].dateDebut :
      moment(this.common.parseDate(this.planning['dateStart'])).format('DD/MM/YYYY');
    const dateend = this.isEdit ? this.eventSelected['detail'].dateFin :
      moment(this.common.parseDate(this.planning['dateEnd'])).format('DD/MM/YYYY');
    const param = {
      'servlet': 'DBGetListChauffeurRH',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.planning['site'] ? this.planning['site'].id || this.common.user[2] : this.common.user[2]
        },
        'DATE': {
          'typeParam': 'date',
          'valeur': 'null'
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': datestart
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': dateend
        },
        'IS_MULTIBENNE': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRE_TEXTE': '' + event,
        'CLEF_QUALIFICATION': {
          'typeParam': 'int',
          'valeur': 0
        },
        'IS_FILTRER_INTERIMAIRES': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'IS_FILTRER_INDISPONIBLES': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'IS_FILTRER_JOUR_TRAVAIL': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'IS_FILTRER_CHAUFFEUR': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_INTERIMAIRES_ASSIGNATION': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'NE_PAS_INCLURE_INTERIMAIRE': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRER_VISIBLE_PLANNING': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRER_ENTRETIEN_BAC': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRER_CONTRAT_PERSO': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'AJOUTER_INTERIMAIRE_EN_MISSION': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`);
        this.dataChauffeur = [...[{ id: 0, libelleObjetEntite: 'Aucun' }], ...datas.data];
      }
    });
  }

  searchChauffeur(event) {
    this.searchChauff(event);
  }

  searchChauffeurSousTraitant(event) {
    const datestart = this.isEdit ? this.eventSelected['detail'].dateDebut :
      moment(this.common.parseDate(this.planning['dateStart'])).format('DD/MM/YYYY');
    const dateend = this.isEdit ? this.eventSelected['detail'].dateFin :
      moment(this.common.parseDate(this.planning['dateEnd'])).format('DD/MM/YYYY');
    const param = {
      'servlet': 'DBGestionMaterielLoue',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_LOCATION_MATERIEL': {
          'typeParam': 'int',
          'valeur': this.isEdit ? this.eventSelected['detail'].id : '0'
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': datestart
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': dateend
        },
        'CRITERE': event || '',
        'CLEF_QUALIF_PERSONEL': {
          'typeParam': 'int',
          'valeur': '0'
        },
        'FILTRER_VISIBLE_PLANNING': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_CONTRAT_PERSO': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_SOUS_TRAITANT': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_AYANT_PRESTATION': {
          'typeParam': 'boolean',
          'valeur': this.common.local.getObject('paramSociete').equipier1PrestationParJour ? true : false
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('.autoPrs').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`);
        this.dataChauffeur = datas.data;
      }
    });
  }

  searchChantier(event) {
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.isEdit ? this.eventSelected['detail'].client.id : this.planning['client'].id
        },
        'CRITERE': event
      }
    };

    if (this.societe['visuChantierDateFin']) {
      param['data']['NBR_MOIS_VISU_CHANTIER'] = {
        'typeParam': 'int',
        'valeur': this.societe['nbrMoisVisuChantier'] || 60
      };
    }

    return this.common.post('', { param: param }).then(datas => {
      $('.autoCht').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = datas.data;
      }
    });
  }

  getChantier(id, edit?) {
    if (id) {
      this.getDetailChantier(id).then(datas => {
        this.isEditChantier = edit ? true : false;
        this.showFichechantier = datas.data[0];
        $('#slide-right').trigger('click');
      });
    } else {
      this.isEditChantier = true;
      this.showFichechantier = {};
      this.addChantier = true;
    }
  }

  getDetailChantier(id) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas;
      }
    });
  }

  hideChantier() {
    this.isEditChantier = false;
    this.showFichechantier = false;
    this.addChantier = false;
  }

  change(value: Boolean): void {
    this.status.isopen = value;
    console.log(this.status.isopen)
    if (this.status.isopen) {
      if (!this.selected.id) {
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      } else {
        setTimeout(function () {
          $('.selected').focus();
        }, 500);
      }
    }
  }

  getMargin() {
    let value;
    switch (this.step) {
      case 1:
        value = !this.isEdit ? '35px' : '18px';
        break;
      case 2:
        value = !this.isEdit ? '17px' : '-1px';
        break;
      case 3:
        value = !this.isEdit ? '5px' : '-14px';
        break;
      case 3.1:
        value = !this.isEdit ? '5px' : '-14px';
        break;
      case 4:
        value = !this.isEdit ? '-10px' : '-26px';
        break;
      case 4.1:
        value = !this.isEdit ? '-10px' : '-26px';
        break;
      case 5:
        value = !this.isEdit ? '-22px' : '-40px';
        break;
      case 5.1:
        value = !this.isEdit ? '-35px' : '-54px';
        break;
      case 6:
        value = !this.isEdit ? '-50px' : '-66px';
        break;
      case 7:
        value = !this.isEdit ? '-62px' : '-79px';
        break;
      case 7.1:
        value = !this.isEdit ? '-75px' : '-93px';
        break;
      case 8:
        value = !this.isEdit ? '-62px' : '-88px';
        break;
      case 9:
        value = !this.isEdit ? '-62px' : '-98px';
        break;
      default:
        value = '55px';
    }

    return value;
  }

  hideCalendar() {
  }

  findCalendar(event) {
    this.objectoldFocus = Object.assign({}, this.objectFocus);
    if (event.target.id !== 'autocomplete') {
      if (this.common.dropdown) {
        this.common.dropdown.hide();
        this.objectFocus = {};
      }
    } else {
      if (this.common.dropdown && this.common.dropdown['ouvert']) {
        this.common.dropdown.show();
        this.objectFocus = Object.assign({}, this.objectoldFocus);
      }
    }
  }

  closeAll(d1, d2) {
    if (d1) {
      d1.close();
    }
    if (d2) {
      d2.close();
    }
  }

  editEvent(event, step, idfocus?) {
    if ((event.detail && !event.detail.histo) || this.is_recreate) {
      this.step = step;
      if (this.step === 3) {
        if (!this.isHistoLoc) {
          setTimeout(function () {
            $('#autofocus').focus();
          }, 1000);
        }

      }

      if (this.step === 3.1) {
        if (!this.isHistoLoc) {
          if (idfocus) {
            setTimeout(function () {
              $(idfocus).click();
            }, 600);
          } else {
            setTimeout(function () {
              $('.sitePrest').click();
            }, 600);
          }
        }
      }

      if (this.step === 4) {
        if (!this.is_recreate) {
          if (this.eventSelected['detail'].article && this.eventSelected['detail'].article.qtePrevisionnelle) {
            this.planning['qtePrevisionnelle'] = this.eventSelected['detail'].article.qtePrevisionnelle;
          }
        }
      }

      if (this.step === 5) {
        if (!this.isHistoLoc) {
          if (idfocus && idfocus != "times") {
            setTimeout(function () {
              $((idfocus === 'date2' ? '#' : '.') + idfocus).focus();
              if (idfocus === 'periode') {
                $((idfocus === 'date2' ? '#' : '.') + idfocus).click();
              }
            }, 100);
          } else if (idfocus && idfocus == "times") {
          } else {
            setTimeout(function () {
              $('#date1').focus();
            }, 100);
          }
        }


        if (!this.is_recreate && event.detail.rappelActif) {
          this.showRappel();
        }
      }
      if (this.step === 9) {
        this.planning['showInfos'] = true;
        if (!this.is_recreate) {
          this.planning['infofact'] = this.eventSelected['detail'].infosFact || '';
          this.planning['infosupp'] = this.eventSelected['detail'].infosSup || '';
        }

        if (!this.isHistoLoc) {
          setTimeout(function () {
            $(idfocus).focus();
          }, 600);
        }

        // this.focusStep();
      }

      if (this.step === 7.1) {
        this.planning['facturation'] = true;
        if (!this.isHistoLoc) {
          setTimeout(function () {
            $(idfocus).focus();
          }, 600);
        }
      }
      if (!this.is_recreate) {
        this.modifier = true;
      }
    } else {
      if (step === 7) {
        this.step = step;
        if (!this.is_recreate) {
          this.modifier = true;
        }
      }
    }
  }

  changeFocus(event, i, value?) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      if (!value) {
        this.planning['showInfo'] = !this.planning['showInfo'];
      } else {
        this.planning['showInfos'] = !this.planning['showInfos'];
      }
    }
    if (event.keyCode === 38 && event.target.previousElementSibling) {
      event.target.previousElementSibling.focus();
      if (!value) {
        this.planning['showInfo'] = !this.planning['showInfo'];
      } else {
        this.planning['showInfos'] = !this.planning['showInfos'];
      }
    }
  }

  changeHeureDebut() {
    if (this.planning['minStart'].length === 2) {
      const date = new Date();
      const heure = this.planning['hourStart'] ? parseInt(this.planning['hourStart'], 10) + 1 : 0;
      const st = '' + heure;
      const start = moment(date.setHours(heure, (this.planning['minStart'] || '00')));
      this.planning['hourEnd'] = start.format('HH:mm:ss').slice(0, -6);
      this.planning['minEnd'] = this.planning['minStart'];
    }
  }

  changeDatePlanning(item) {
    const val = this.planning[item];
    // console.log(item, val);
    if (val && typeof val === 'string') {
      const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
      if (type) {
        this.planning[item] = this.common.parseDate(val);
        // console.log(item, this.planning[item])
        this.getlistIndispo();
      }
    }
  }

  showInfoSupp(event) {
    this.planning['showInfos'] = true;
    setTimeout(function () {
      $('[autofocus]').focus();
    }, 500);
  }

  nextFocus() {
    $('#infosup').focus();
  }

  showComboDemandeur() {
    this.planning['showcombo'] = !this.planning['showcombo'];
    setTimeout(function () {
      $('[tabindex=0]').focus();
    }, 1000);
  }

  focusNextClt(showInfo) {
    this.planning['showInfos'] = showInfo;
    if (showInfo) {
      $('.clientdmd').focus();
    } else {
      $('.client1').focus();
    }
  }

  showRappel() {
    this.planning['showRappel'] = true;
    this.planning['rappel'] = this.selected.id ? this.selected : this.rappel[0];
    this.planning['rappelLibre'] = this.planning['rappelLibre'] || this.typerappel[0];
  }

  recalculDateRapel() {
    if (this.planning['showRappel'] || (this.isEdit && this.eventSelected && this.eventSelected.detail && this.eventSelected.detail.rappelActif)) {
      if (!this.planning['israppelLibre']) {
        this.selectRappel(this.selected);
      } else {
        this.rappelLibreChange();
      }
    }
  }

  changeRappelLibre(event) {
    if (this.planning['israppelLibre']) {
      this.selected = this.rappel[0];
      this.selectRappel(this.rappel[0]);
    } else {
      this.planning['rappelLibre'] = this.typerappel[0];
      this.planning['rappelLibreValeur'] = '';
      this.rappelLibreChange();
    }
    if (this.isEdit) {
      this.eventSelected['detail'].rappelLibre = this.planning['israppelLibre'];
      this.eventSelected['detail'].rappelActif = this.planning['israppelLibre'];
    }
  }

  selectRappel(event, evt?) {
    this.planning['rappel'] = event;
    this.status.isopen = false;
    const day = this.common.parseDate(moment(this.planning['dateStart']).format('DD/MM/YYYY'), (this.planning['hourStart'] || '00'),
      (this.planning['minStart'] || 0));
    switch (event.id) {
      case '0':
        break;
      case '1':
        this.planning['rappel'].value = moment(day).subtract(5, 'minutes').format('DD/MM/YYYY HH:mm:ss');
        break;
      case '2':
        this.planning['rappel'].value = moment(day).subtract(15, 'minutes').format('DD/MM/YYYY HH:mm:ss');
        break;
      case '3':
        this.planning['rappel'].value =
          moment(day).subtract(30, 'minutes').format('DD/MM/YYYY HH:mm:ss');
        break;
      case '4':
        this.planning['rappel'].value = moment(day).subtract(1, 'hours').format('DD/MM/YYYY HH:mm:ss');
        break;
      case '5':
        this.planning['rappel'].value = moment(day).subtract(2, 'hours').format('DD/MM/YYYY HH:mm:ss');
        break;
      case '6':
        this.planning['rappel'].value = moment(day).subtract(1, 'days').format('DD/MM/YYYY HH:mm:ss');
        break;
      case '7':
        this.planning['rappel'].value = moment(day).subtract(2, 'days').format('DD/MM/YYYY HH:mm:ss');
        break;
    }
    if (this.isEdit) {
      if (event.id !== '0') {
        this.eventSelected['detail'].rappelActif = true;
        this.eventSelected['detail'].rappel = this.planning['rappel'].value;
        this.eventSelected['detail'].valeurRappelLibre = '';
        this.eventSelected['detail'].typeRappelLibre = '';
      } else {
        this.eventSelected['detail'].rappelActif = false;
        this.eventSelected['detail'].rappel = '';
        this.eventSelected['detail'].valeurRappelLibre = '';
        this.eventSelected['detail'].typeRappelLibre = '';
      }

    }
  }

  keyEnterHideInput() {
    console.log('step', this.step)
    if (this.step === 7 && !this.planning.isPartenaire) {
      this.setValuePlanning('chauff');
      this.planning.isPartenaire = this.param.gestionCQC ? true : false;
    }
  }

  toggleDropdown($event?: MouseEvent, isop?): void {
    if (isop) {
      this.status.isopens = !this.status.isopens;
    } else {
      this.status.isopen = !this.status.isopen;
    }
  }

  rappelLibreChange() {
    const day = this.common.parseDate(moment(this.planning['dateStart']).format('DD/MM/YYYY'), (this.planning['hourStart'] || '00'),
      (this.planning['minStart'] || 0));
    if (this.planning['rappelLibreValeur'] !== 0 && this.planning['rappelLibre']) {
      switch (this.planning['rappelLibre'].id) {
        case '0':
          this.planning['rappel'].value =
            moment(day).subtract(parseInt(this.planning['rappelLibreValeur'], 10), 'minutes').format('DD/MM/YYYY HH:mm:ss');
          break;
        case '1':
          this.planning['rappel'].value =
            moment(day).subtract(parseInt(this.planning['rappelLibreValeur'], 10), 'hours').format('DD/MM/YYYY HH:mm:ss');
          break;
        case '2':
          this.planning['rappel'].value =
            moment(day).subtract(parseInt(this.planning['rappelLibreValeur'], 10), 'days').format('DD/MM/YYYY HH:mm:ss');
          break;
      }
      if (this.isEdit) {
        this.eventSelected['detail'].valeurRappelLibre = this.planning['rappelLibreValeur'];
        this.eventSelected['detail'].typeRappelLibre = this.planning['rappelLibre'].id;
        this.eventSelected['detail'].rappel = this.planning['rappel'].value;
      }
    } else if (!this.planning['rappelLibreValeur'] && this.planning['rappelLibre']) {
      this.selectRappel(this.rappel[0])
      if (this.isEdit) {
        this.eventSelected['detail'].valeurRappelLibre = this.planning['rappelLibreValeur'];
        this.eventSelected['detail'].typeRappelLibre = this.planning['rappelLibre'].id;
        this.eventSelected['detail'].rappel = this.planning['rappel'].value;
      }
    }
  }

  changerappelFocus(event, i) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }
    if (event.keyCode === 38 && event.target.previousElementSibling) {
      event.target.previousElementSibling.focus();
    }
  }

  detectIsopen(event) {
    this.status.isopens = event;
  }


  setFocuscalendar(event) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }
  }

  showFiche() {
    this.showFicheclt = !this.showFicheclt;
  }

  showHistoPrest() {
    this.showHistorique = !this.showHistorique;
  }

  createChantier(event) {
    event.nomclass = 'Chantier';
    event.siteChantier = {
      id: this.common.user[2]
    };
    const param = {
      'servlet': 'DBSaveChantierHolding',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBSaveChantierHolding'], event, {
        id: this.planning['client'] ? this.planning['client'].id : 0,
        nomclass: 'Client'
      }]
    };
    this.hideChantier();
    this.common.post('', { param: param }).then(datas => {
      $('.slide-prestation').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data !== null) {
          if ( !this.isDepuisEcocontrat && this.eventSelected && this.eventSelected['detail']) {
            this.getDetail(this.eventSelected['detail'].id);
          }
          if (datas.data[0]) {
            event['id'] = datas.data[0];
            this.getDetailChantier(datas.data[0]).then(dt => {
              this.selectedChantier = event;
              this.planning['chantier'] = event;
              this.objEquipe['listLieu'] = this.selectedChantier['listLieu'] || [];
              this.searchChantier(event.numChantier);
              this.common.createLog('108', datas.data[0], true);
              setTimeout(function () {
                $('#autocomplete').focus();
              }, 500);
            });
          }
        }
      }
    });
  }

  updateChantier(event) {
    if (this.eventSelected && this.eventSelected['detail'] && this.eventSelected['detail'].id) {
      if (!this.isDepuisEcocontrat) {
        this.getDetail(this.eventSelected['detail'].id);
      }
    } else {
      this.selectedChantier = event;
      this.planning['chantier'] = event;
    }
  }

  showFicheCltadd() {
    this.addClient = !this.addClient;
    this.showFiche();
    if (!this.showFicheclt) {
      setTimeout(function () {
        $('#autocomplete').focus();
      }, 500);
    }
  }

  afterAddClt(event) {
    this.planning['client'] = event;
  }

  finFunction(event) {
    if (this.isEdit) {
      this.setValuePlanning(event);
    } else {
      this.generateBon();
    }
  }

  changeProgram() {
    if (this.planning['program']) {
      this.mouvBenneProgramme['typeProgram'] = this.listProgram[1];
      this.mouvBenneProgramme['frequence'] = 1;
      this.mouvBenneProgramme['typeOperation'] = 0;
      this.mouvBenneProgramme['listTtSemaine'] = [];
      this.mouvBenneProgramme['listSemainePaire'] = [];
      this.mouvBenneProgramme['listSemaineImpaire'] = [];
      this.mouvBenneProgramme['listJoursMois'] = [];
      this.mouvBenneProgramme['listJoursMois1'] = [];
      this.mouvBenneProgramme['listJoursMois2'] = [];
      this.mouvBenneProgramme['listJoursMois3'] = [];
      this.mouvBenneProgramme['listJoursMois4'] = [];
      this.mouvBenneProgramme['listJoursMois5'] = [];
      this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
    }
  }

  mvtProgramme() {
    if (this.mouvBenneProgramme['id'] || (this.isDepuisEcocontrat && (this.mouvBenneProgramme['id'] === 0))) {
      if (this.mouvBenneProgramme['typeOperation']) {
        this.listProgram.forEach(elt => {
          if (elt.id === this.mouvBenneProgramme['typeOperation']) {
            this.mouvBenneProgramme['typeProgram'] = elt;
          }
        });
      } else {
        this.mouvBenneProgramme['typeProgram'] = this.listProgram[1];
      }
      if (this.mouvBenneProgramme['dateFin']) {
        this.mouvBenneProgramme['editDate'] = true;
        if (this.mouvBenneProgramme['dateFin'] !== '01/01/1970 00:00:00') {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate(moment((this.mouvBenneProgramme['dateFin']),
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        } else {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate('31/12/9999');
        }
      }
      this.mouvBenneProgramme['nbSemainesProgram'] = '' + (this.mouvBenneProgramme['nbSemainesProgram'] || 1);
      this.mouvBenneProgramme['frequence'] = this.mouvBenneProgramme['frequence'] || 0;
      this.mouvBenneProgramme['listTtSemaine'] = [];
      this.mouvBenneProgramme['listSemainePaire'] = [];
      this.mouvBenneProgramme['listSemaineImpaire'] = [];
      this.mouvBenneProgramme['listJoursMois'] = [];
      this.mouvBenneProgramme['listJoursMois1'] = [];
      this.mouvBenneProgramme['listJoursMois2'] = [];
      this.mouvBenneProgramme['listJoursMois3'] = [];
      this.mouvBenneProgramme['listJoursMois4'] = [];
      this.mouvBenneProgramme['listJoursMois5'] = [];
      this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
      this.mouvBenneProgramme['listePeriodesPause'] = this.mouvBenneProgramme['listePeriodesPause'] || [];
      this.mouvBenneProgramme['typeOperation'] = this.mouvBenneProgramme['typeOperation'] || 0;
      switch (this.mouvBenneProgramme['typeOperation']) {
        case 0:
          if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
            this.mouvBenneProgramme['listTtSemaine'] = this.mouvBenneProgramme['listJours'] || [];
          } else {
            // this.mouvBenneProgramme['listSemainePaire'] = this.mouvBenneProgramme['listJours'] || [];
            // this.mouvBenneProgramme['listSemaineImpaire'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
            this.mouvBenneProgramme['listSemainePaire'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
            this.mouvBenneProgramme['listSemaineImpaire'] = this.mouvBenneProgramme['listJours'] || [];
          }
          break;
        case 1:
          this.mouvBenneProgramme['listJoursMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
        case 2:
          this.mouvBenneProgramme['listJoursMois1'] = this.mouvBenneProgramme['listJours'] || [];
          this.mouvBenneProgramme['listJoursMois2'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
          this.mouvBenneProgramme['listJoursMois3'] = this.mouvBenneProgramme['listJoursSemaine3'] || [];
          this.mouvBenneProgramme['listJoursMois4'] = this.mouvBenneProgramme['listJoursSemaine4'] || [];
          this.mouvBenneProgramme['listJoursMois5'] = this.mouvBenneProgramme['listJoursSemaine5'] || [];
          break;
        case 3:
          this.mouvBenneProgramme['listJoursDerSemaineMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
      }
    }
  }

  createObjtMvtBennePgm() {
    if (this.mouvBenneProgramme['tableConfigJoursFeries']) {
      this.mouvBenneProgramme['tableConfigJoursFeries'].forEach(elt => {
        if (elt.configJourFerie) {
          elt.configJourFerie.rattrapageLendemain = elt.configJourFerie.rattrapageLendemain || false;
        }
      });
    }

    this.mouvBenneProgramme['listMouvementsParPeriode'] = this.mouvBenneProgramme['listMouvementsParPeriode'] || [];
    this.mouvBenneProgramme['listMouvementsParPeriode'].forEach(element => {
      element.id = element.id > 0 ? element.id : 0;
    });

    const mouv = {
      id: this.mouvBenneProgramme['id'] || 0,
      typeOperation: this.mouvBenneProgramme['typeOperation'],
      frequence: this.mouvBenneProgramme['frequence'],
      tableConfigJoursFeries: this.mouvBenneProgramme['tableConfigJoursFeries'],
      listePeriodesPause: this.mouvBenneProgramme['listePeriodesPause'],
      listMouvementsParPeriode: this.mouvBenneProgramme['listMouvementsParPeriode'] || [],
      // nomclass: 'MouvementBenneProgramme',
    };
    switch (this.mouvBenneProgramme['typeOperation']) {
      case 0:
        mouv['nbSemainesProgram'] = this.mouvBenneProgramme['nbSemainesProgram'];
        if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
          mouv['listJours'] = this.mouvBenneProgramme['listTtSemaine'] || [];
        } else {
          // mouv['listJours'] = this.mouvBenneProgramme['listSemainePaire'] || [];
          // mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJours'] = this.mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listSemainePaire'] || [];
        }
        break;
      case 1:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois'] || [];
        break;
      case 2:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois1'] || [];
        mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listJoursMois2'] || [];
        mouv['listJoursSemaine3'] = this.mouvBenneProgramme['listJoursMois3'] || [];
        mouv['listJoursSemaine4'] = this.mouvBenneProgramme['listJoursMois4'] || [];
        mouv['listJoursSemaine5'] = this.mouvBenneProgramme['listJoursMois5'] || [];
        break;
      case 3:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursDerSemaineMois'] || [];
        break;
    }

    // if (this.mouvBenneProgramme['editDate']) {
    //   mouv['dateFin'] = moment(this.mouvBenneProgramme['datePgm']).format('DD/MM/YYYY');
    // }

    if (this.mouvBenneProgramme['editDate']) {
      // console.log(this.mouvBenneProgramme['datePgm'])
      if (this.mouvBenneProgramme['datePgm'] && typeof this.mouvBenneProgramme['datePgm'] === 'string' &&
        this.mouvBenneProgramme['datePgm'].match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
        mouv['dateFin'] = this.mouvBenneProgramme['datePgm'];
      } else {
        if (moment(this.mouvBenneProgramme['datePgm']).isValid()) {
          mouv['dateFin'] = moment(this.mouvBenneProgramme['datePgm']).format('DD/MM/YYYY');
        }
        if (!this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '') {
          mouv['dateFin'] = '31/12/9999';
        }
      }
    }

    return this.planning['program'] ? mouv : null;
  }

  changeFrequence() {
    if (this.mouvBenneProgramme['nbSemainesProgram'] === '2') {
      this.mouvBenneProgramme['frequence'] = 1;
    }
  }

  showJourFerie() {
    this.isJourFerie = !this.isJourFerie;
  }

  saveJourFerier(event) {
    this.mouvBenneProgramme['tableConfigJoursFeries'] = event;
  }

  savePeriode(event) {
    this.mouvBenneProgramme = event;
  }

  showSuspension() {
    this.isSuspension = !this.isSuspension;
  }

  saveSuspension(event) {
    this.mouvBenneProgramme['listePeriodesPause'] = event;
  }

  selectedDay(list, elem) {
    if (elem > 0) {
      const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
      return listfilter.length ? true : false;
    } else {
      return false;
    }
  }

  selectedSemaine(list, elem) {
    list = list || [];
    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    return listfilter.length ? true : false;
  }

  checkDayWeek(list, elem) {
    // let list = [];

    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    if (listfilter.length) {
      let index;
      list.forEach((elt, idx) => {
        if (parseInt(elt, 10) === parseInt(elem, 10)) {
          index = idx;
        }
      });
      // const index = list.indexOf('' + 5);
      list.splice(index, 1);
      list = [...list];
    } else {
      list.push('' + elem);
      list = [...list];
    }
  }

  changeDatePgm(event) {
    if (moment(event).isValid()) {
      this.mouvBenneProgramme['dateFin'] = moment(event).format('DD/MM/YYYY');
    } else {
      this.mouvBenneProgramme['dateFin'] = !this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '' ?
        '31/12/9999' : moment().format('DD/MM/YYYY');
    }
  }

  showMessage() {
    this.showMsg = !this.showMsg;
  }

  showDocument() {
    this.showDoc = !this.showDoc;
  }

  showProgrammation() {
    if (this.planning['program']) {
      this.isProgrammation = !this.isProgrammation;
      console.log('mouvBenneProgramme', this.mouvBenneProgramme)
    }
  }

  openModalConfirme() {
    if (this.common.getDiffDate(this.planning.dateStart, this.planning.dateEnd, false, true) < 0) {
      this.error = 'La date de début est supérieur à la date de fin.';
      this.common.openModal(this.modalService, this.msg)
      return false;
    }

    if (this.common.getDiffDate(this.planning.dateStart, this.planning.dateEnd, false, true) === 0 && this.testHour() < 0) {
      this.error = ' L\'heure de début est supérieure à l\'heure de fin.';
      this.common.openModal(this.modalService, this.msg)
      return false;
    }

    if (!this.common.isTimeValid(this.formatedHeureDebut()) || !this.common.isTimeValid(this.formatedHeureFin())) {
      this.error = "Le format de l'heure n'est pas valide. Il faut que :\n" +
        "- le format soit de la forme HH:mm:ss\n" +
        "- l'heure ne dépasse pas le 23\n" +
        "- la minute ne dépasse pas le 59";
      this.common.openModal(this.modalService, this.champInvalid)
      return false;
    }

    const program = this.createObjtMvtBennePgm();
    if (this.planning['program'] && program !== null && program.id > 0) {
      this.common.openModal(this.modalService, this.programConfirme);
    } else {
      this.validerUpdate();
    }
  }

  getDetailClient(id) {
    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.client = datas.data ? datas.data[0] : {};
        this.client['codeBlocage'] = this.common.getCodeBlocageClient(this.client, parseInt(this.common.user[2], 10));
        if (this.isDepuisEcocrm) {
          this.planning['client'].libelleObjetEntite = this.clientToString(this.client);
        }
      }
    });
  }

  clientToString(c) {
    const s1 = (c.codeClient || '') + (c.codeClient ? '/' : '') + (c.nomClient || '');
    const s2 = (c.prenom || '') + (c.prenom ? '/' : '') + (c.ville || '');
    return s1 + ' ' + s2;
  }

  anotheExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listExutoire = datas.data;
      }
    });
  }

  isChauffeurIndispoInfoBulle(element, chauffeur) {
    let isIndispo = false;
    if (!element.listeIndisponibiliteChauffeurs || !chauffeur) {
      return false;
    }

    element.listeIndisponibiliteChauffeurs.forEach(c => {
      const aStart = this.common.parseDate(moment(c.dateDebut, 'DD/MM/YYYY').format('DD/MM/YYYY'));
      const aEnd = this.common.parseDate(moment(c.dateFin, 'DD/MM/YYYY').format('DD/MM/YYYY'));
      const bStart = this.common.parseDate(moment(element.dateDebut, 'DD/MM/YYYY').format('DD/MM/YYYY'));
      const bEnd = this.param['prestEcolocVision1Jour'] ? bStart :
        this.common.parseDate(moment(element.dateFin, 'DD/MM/YYYY').format('DD/MM/YYYY'));
      const range1 = moment(bStart).isSameOrAfter(aStart) && moment(bStart).isSameOrBefore(aEnd);
      const range2 = moment(bEnd).isSameOrAfter(aStart) && moment(bEnd).isSameOrBefore(aEnd);
      if (!c.indispoChauffeurRemplacant && c.chauffeur && c.chauffeur.id === chauffeur.id && (range2 || range1)) {
        isIndispo = true;
      }
    });

    return isIndispo;
  }

  isChauffeurIndispo(chauffeur) {
    let isIndispo = false;
    if (!this.listIndispoChauff || !chauffeur) {
      return false;
    }

    this.listIndispoChauff = this.listIndispoChauff || [];
    this.listIndispoChauff.forEach(c => {
      const aStart = this.common.parseDate(moment(c.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const aEnd = this.common.parseDate(moment(c.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const bStart = this.common.parseDate(moment(this.planning['dateStart']).format('DD/MM/YYYY'));
      const bEnd = this.common.parseDate(moment(this.planning['dateEnd']).format('DD/MM/YYYY'));
      const range1 = moment(bStart).isSameOrAfter(aStart) && moment(bStart).isSameOrBefore(aEnd);
      const range2 = moment(bEnd).isSameOrAfter(aStart) && moment(bEnd).isSameOrBefore(aEnd);
      if (c.ressource && c.ressource.id === chauffeur.id && (range2 || range1)) {
        isIndispo = true;
      }
    });

    return isIndispo;
  }

  // RecylogIHM -> PanneauLocation.java (Ligne 1433)  
  /*
  isChauffeurDispo(listeIndispoChauffeur, ch) {
      if(ch && ch.id > 0 && listeIndispoChauffeur.length > 0) {
          let isDispo = true;
          listeIndispoChauffeur.forEach(i => {
              if(i.ressource && i.ressource.id && i.ressource.id === ch.id) {
                  isDispo = false;
              }
          });
          
          return isDispo;
      }
      return true;
  }
  */

  parseMouvement() {
    console.log('Calling parseMouvement()');
    const ctrl = this;
    const planning = this.eventSelected && this.eventSelected.detail ? this.eventSelected.detail || this.planning : this.planning;

    planning['chauffeur'] = !this.isChauffeurIndispoInfoBulle(planning, planning['chauffeur']) ?
      Object.assign({}, planning['chauffeur']) : { id: 0, libelleObjetEntite: 'A définir' };

    planning['listePersonnelParPoste'] = planning['listePersonnelParPoste'] || [];
    planning['listePersonnelParPoste'].forEach(e => {
      e.chauffeur = e.chauffeur || { id: 0, libelleObjetEntite: 'A définir' };
      if (e.chauffeur.id && !e.chauffeur.posteSupprime) {
        e.chauffeur = !this.isChauffeurIndispoInfoBulle(planning, e.chauffeur) ?
          e.chauffeur : { id: 0, libelleObjetEntite: 'A définir' };
      }
    });

    // RecylogIHM -> PanneauGestionEquipe3.java (Ligne 1741)
    // this.getlistIndispo(false).then(datasListIndispo => { // Récupérer la liste des indisponibilités
    //    let listeIndispoChauffeur = datasListIndispo || [];
        
        // Regarder si le chauffeur leader est indisponible sur cette date, si c'est le cas le mettre en "A définir"
        /*
        if(!ctrl.isChauffeurDispo(listeIndispoChauffeur, planning['chauffeur'])) {
           planning['chauffeur'] = { id: 0 };
        } 
        */           
        
        const data = Object.assign({}, planning);
        data['listePersonnelParPoste'] = data['listePersonnelParPoste'] || [];
        ctrl.objEquipe['listePersonnelParPoste'] = [];
        const poctuelPost = [];
        data['listePersonnelParPoste'].forEach(e => {
          const elt = Object.assign({}, e);
          elt.chauffeur = elt.chauffeur || { id: 0 };
          elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
            ''} ${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';
          elt['lieuChantier'] = elt['chauffeur'] ?
            elt['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
          elt['lieuDepart'] = elt['chauffeur'] ?
            elt['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
          
          /*
          // Regarder si ce personnel ponctuel est indisponible sur cette date, si c'est le cas le mettre en "A définir"
          if(!ctrl.isChauffeurDispo(listeIndispoChauffeur, elt.chauffeur)) {
             elt.chauffeur = { id: 0 };
          }
          */

          poctuelPost.push(elt);
        });


        ctrl.objEquipe['site'] = planning['site'];
        ctrl.objEquipe['modeEquipe'] = planning['equipeDefinie'] || false;
        ctrl.objEquipe['mouvement'] = Object.assign({}, planning || { id: 0 });
        ctrl.objEquipe['chantier'] = Object.assign({}, ctrl.planning['chantier']);
        ctrl.objEquipe['chauffeur'] = Object.assign({}, planning['chauffeur']);
        ctrl.objEquipe['chauffeur'].libelleObjetEntite = ctrl.objEquipe['chauffeur'] && ctrl.objEquipe['chauffeur'].id ?
          `${ctrl.objEquipe['chauffeur'].matricule || ''} ${ctrl.objEquipe['chauffeur'].nom ||
          ''} ${ctrl.objEquipe['chauffeur'].prenom || ''}` : '';
        ctrl.objEquipe['lieuChantier'] = ctrl.objEquipe['chauffeur'] ?
          ctrl.objEquipe['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
        ctrl.objEquipe['lieuDepart'] = ctrl.objEquipe['chauffeur'] ?
          ctrl.objEquipe['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
        const benne = data['materielLoue'] || {};
        if (benne) {
          ctrl.objEquipe['modeEquipe'] = benne.equipeDefinie || false;
          ctrl.objEquipe['program'] = benne.clefProgram && (benne.clefProgram !== '' || benne.clefProgram !== '0') ? true : false;
          ctrl.objEquipe['qualificationLeader'] = benne.qualificationLeader;
          ctrl.objEquipe['leaderEquipe'] = benne.leaderEquipe || { id: 0 };
          if (ctrl.objEquipe['leaderEquipe'].id) {
            ctrl.objEquipe['leaderEquipe'] = ctrl.objEquipe['leaderEquipe'];
          }
          ctrl.objEquipe['leaderEquipe']['libelleObjetEntite'] = ctrl.objEquipe['leaderEquipe'] && ctrl.objEquipe['leaderEquipe'].id ?
            `${ctrl.objEquipe['leaderEquipe']['matricule']
            || ''} ${ctrl.objEquipe['leaderEquipe']['nom']
            || ''} ${ctrl.objEquipe['leaderEquipe']['prenom'] || ''}` : '';
          ctrl.objEquipe['lieuChantierParDefaut'] = ctrl.objEquipe['leaderEquipe'] ?
            ctrl.objEquipe['leaderEquipe'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
          ctrl.objEquipe['lieuDepartParDefaut'] = ctrl.objEquipe['leaderEquipe'] ?
            ctrl.objEquipe['leaderEquipe'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
          // if (ctrl.objEquipe['program']) {
          benne.listePersonnelParPoste = benne.listePersonnelParPoste || [];

          const posteMax = benne.listePersonnelParPoste.length > poctuelPost.length ? benne.listePersonnelParPoste.length : poctuelPost.length;

          // L'ordre des objets PosteEquipe "ponctuel et défaut" ne sont pas ordonné sur la réponse du serveur, surtout quand leurs length est différent
          // Cela fausse l'expression en bas ... for (let i = 0; i < posteMax; i++) { ... objpost['poste'] = objpost['poste'] || eltObjetEquipeParDefaut.poste; ...
          // Car l'index "i" n'est pas forcément le même poste.id sur les deux listes
          // Il faut l'arranger avant de construire ctrl.objEquipe['listePersonnelParPoste']
          let listeObjetEquipeParDefaut = [];
          if (benne.listePersonnelParPoste.length >= poctuelPost.length) {
            poctuelPost.forEach(eltObjetEquipePonctuel => {
              benne.listePersonnelParPoste.forEach(eltObjetEquipeParDefaut => {
                if (eltObjetEquipePonctuel['poste'].id === eltObjetEquipeParDefaut['poste'].id) {
                  listeObjetEquipeParDefaut.push(eltObjetEquipeParDefaut);
                }
              });
            });

            // Tous les élements de la liste d'ObjetEquipePonctuel sont maintenant dans listeObjetEquipeParDefaut
            // Mais il reste certains élements de la liste d'ObjetEquipeParDefaut à ajouter
            benne.listePersonnelParPoste.forEach(eltObjetEquipeParDefaut => {
              let existeDejaDansLaListe = false;
              poctuelPost.forEach(eltObjetEquipePonctuel => {
                if (eltObjetEquipePonctuel['poste'].id === eltObjetEquipeParDefaut['poste'].id) {
                  existeDejaDansLaListe = true;
                }
              });

              if (!existeDejaDansLaListe) {
                listeObjetEquipeParDefaut.push(eltObjetEquipeParDefaut);
              }
            });
          } else {
            // A voir si on doit aussi gérer à ordonner le cas ou benne.listePersonnelParPoste.length < poctuelPost.length
            listeObjetEquipeParDefaut = benne.listePersonnelParPoste;
          }

          for (let i = 0; i < posteMax; i++) {
            const objpost = poctuelPost[i] ? Object.assign({}, poctuelPost[i]) : { id: 0 };
            const eltObjetEquipeParDefaut = listeObjetEquipeParDefaut[i] ? Object.assign({}, listeObjetEquipeParDefaut[i]) : { id: 0 };
            eltObjetEquipeParDefaut.chauffeur = eltObjetEquipeParDefaut.chauffeur || { id: 0 };
            eltObjetEquipeParDefaut.chauffeur['libelleObjetEntite'] = eltObjetEquipeParDefaut.chauffeur && eltObjetEquipeParDefaut.chauffeur.id ? `${eltObjetEquipeParDefaut.chauffeur['matricule'] ||
              ''} ${eltObjetEquipeParDefaut.chauffeur['nom'] || ''} ${eltObjetEquipeParDefaut.chauffeur['prenom'] || ''}` : '';
            objpost['poste'] = objpost['poste'] || eltObjetEquipeParDefaut.poste;
            objpost['personnelDefaut'] = eltObjetEquipeParDefaut.chauffeur;
            objpost['lieuChantierParDefaut'] = eltObjetEquipeParDefaut['chauffeur'] ?
              eltObjetEquipeParDefaut['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
            objpost['lieuDepartParDefaut'] = eltObjetEquipeParDefaut['chauffeur'] ?
              eltObjetEquipeParDefaut['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };

            ctrl.objEquipe['listePersonnelParPoste'].push(objpost);
          }

        }
        // console.log(ctrl.objEquipe['listePersonnelParPoste'])
    //});
  }

  objMvtEquipe() {
    const ObjetRetour: any = {};
    ObjetRetour.listePersonnelParPoste = [];
    ObjetRetour.listePersonnelParPosteMvt = [];
    ObjetRetour.listePostes = [];
    ObjetRetour.leaderEquipe = this.objEquipe['leaderEquipe'] || { id: 0 };
    ObjetRetour.leaderEquipe.lieuChantier = this.objEquipe['lieuChantierParDefaut'] || { id: 0 };
    ObjetRetour.leaderEquipe.lieuDepart = this.objEquipe['lieuDepartParDefaut'] || { id: 0 };
    ObjetRetour.qualificationLeader = this.objEquipe['qualificationLeader'] || { id: 0 };
    ObjetRetour.chauffeur = this.objEquipe['chauffeur'] || { id: 0 };
    ObjetRetour.chauffeur.lieuChantier = this.objEquipe['lieuChantier'] || { id: 0 };
    ObjetRetour.chauffeur.lieuDepart = this.objEquipe['lieuDepart'] || { id: 0 };
    ObjetRetour.modeEquipe = this.objEquipe['modeEquipe'] || false;
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    let i = 0;
    this.objEquipe['listePersonnelParPoste'].forEach((elt, index) => {
      elt.poste = elt.poste || { id: 0 };
      if ((elt.poste && !elt.poste.id) || this.is_recreate) {
        i = i + 1;
      }
      // console.log('is_create', this.is_recreate);
      elt.poste.id = this.is_recreate ? (-1 * (i)) : (elt.poste.id || (-1 * (i)));

      elt.poste.qualification = elt.poste.qualification || { id: 0 };
      elt.poste.qualification['nomclass'] = 'QualificationPersonnel';
      ObjetRetour.listePostes.push(elt.poste);
      const defaut = {
        id: 0,
        poste: elt.poste,
        chauffeur: {
          id: elt.personnelDefaut ? (elt.personnelDefaut.id) || 0 : 0,
          nom: elt.personnelDefaut ? (elt.personnelDefaut.nom) || '' : '',
          prenom: elt.personnelDefaut ? (elt.personnelDefaut.prenom) || '' : '',
          libelleObjetEntite: elt.personnelDefaut ? (elt.personnelDefaut.libelleObjetEntite) || '' : '',
          lieuChantier: elt.lieuChantierParDefaut,
          lieuDepart: elt.lieuDepartParDefaut,
        }
      };
      const ponctuel = {
        id: 0,
        poste: elt.poste,
        chauffeur: {
          id: elt.chauffeur ? (elt.chauffeur.id) || 0 : 0,
          nom: elt.chauffeur ? (elt.chauffeur.nom) || '' : '',
          prenom: elt.chauffeur ? (elt.chauffeur.prenom) || '' : '',
          libelleObjetEntite: elt.chauffeur ? (elt.chauffeur.libelleObjetEntite) || '' : '',
          lieuChantier: elt.lieuChantier,
          lieuDepart: elt.lieuDepart,
          posteSupprime: elt.chauffeur ? (elt.chauffeur.posteSupprime) || false : false,
        }
      }
      ObjetRetour.listePersonnelParPoste.push(defaut);
      ObjetRetour.listePersonnelParPosteMvt.push(ponctuel);
    });
    ObjetRetour.equipeDefinie = ObjetRetour.listePostes.length > 0 ? true : false;
    // console.log(ObjetRetour)
    return ObjetRetour;
  }

  showEquipeFct() {
    this.objEquipe['id'] = this.isEdit && this.eventSelected && this.eventSelected.detail ? (this.eventSelected.detail['id'] || 0) : 0;
    this.objEquipe['program'] = this.planning['program'] || false;
    this.idSitePrestEdit = this.planning['sitePrest'] && this.planning['sitePrest'].id ? this.planning['sitePrest'].id : '';
    this.isModeEquipe = !this.isModeEquipe;
    // console.log('After close : ', this.objEquipe);
    // }
  }

  saveEquipe(event) {
    // console.log(event);
    this.objEquipe = Object.assign({}, event);
    // console.log('After save : ', this.objEquipe);

    if (this.isEdit) {
      this.eventSelected.detail['chauffeur'] = this.objEquipe['chauffeur'];
      this.eventSelected.detail['listePersonnelParPoste'] = [];
      this.objEquipe['listePersonnelParPoste'].forEach(equipe =>
        this.eventSelected.detail['listePersonnelParPoste'].push(Object.assign({}, equipe)));
    } else {
      this.equipes = [];
      this.planning['chauffeur'] = this.objEquipe['chauffeur'];
      this.equipes.push(Object.assign({}, this.objEquipe['chauffeur'] || { id: 0, libelleObjetEntite: 'Aucun' }));
      this.objEquipe['listePersonnelParPoste'].forEach(equipe => {
        const chauff = equipe.chauffeur || { id: 0, libelleObjetEntite: 'A définir' };
        chauff.libelleObjetEntite = chauff.id ? `${chauff.matricule ? chauff.matricule + ' ' : ''}
         ${chauff.nom ? chauff.nom + ' ' : ''} ${chauff.prenom || ''}` : 'A définir';
        this.equipes.push(Object.assign({}, equipe.chauffeur));
      });
    }
    this.isModeEquipe = !this.isModeEquipe;
  }

  getToutesRsrcBSDDPlanningGeneral() {
    this.imprimerTousLesBSDD();
  }

  imprimerTousLesBSDD() {

    const param = {
      'servlet': 'DBImprimeBSDDBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/BSDD/',
      'data': {
        'ID_BON': {
          'typeParam': 'int',
          'valeur': this.eventSelected['detail'].bon['id'] || 0
        },
        'IS_BON_ECOLOC ': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'BSDD_MANUEL': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IMP_DND': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        const bon = this.eventSelected['detail'].bon;
        if (datas.data === 'KO') {
          this.error = `Cet article n'est pas un DD.\nVous ne pouvez pas imprimer de BSDD.`;
          this.common.openModal(this.modalService, this.msg);
        } else {
          datas.data.forEach(elt => {
            this.common.openFile(elt);
          });
        }
      } else {
        if (datas.message) {
          this.error = datas.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }

  getListeSite() {
    this.listeSite = this.common.getType('tousSite') || [];
    this.isShowSite = this.listeSite.length > 1 ? true : false;
    // console.log(this.listeSite.length);
    this.listeSite.forEach(elt => {
      if (elt.id === this.common.user[2]) {
        this.defaultSite = elt;
        this.defaultSiteCA = elt;
      }
    });
  }

  searchSite(event) {
    this.listeSiteCA = [];
    this.listeSite.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
      this.listeSiteCA.push(elt);
    });
  }

  recreatePrest(event) {
    this.showHistoPrest();
    // console.log(event)
    this.isEdit = false;
    this.planning = {};
    this.objEquipe = {};
    this.equipes = [];
    this.formatData(event)
  }

  getlistIndispo() {
    const param = {
      'servlet': 'DBGestionIndisponibiliteChauffeur',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': moment(this.planning['dateStart']).format('DD/MM/YYYY')
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': moment(this.planning['dateEnd']).format('DD/MM/YYYY')
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listIndispoChauff = datas.data || [];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });

  }

  getlistMotifSuppressionEcoloc() {
    const param = {
      'servlet': 'DBGetListMotifSuppressionEcoloc',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {}
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.dataMotifSuppression = datas.data || [];
      }
    });

  }

  formatData(detail) {
    const ctrl = this;
    if (this.param['gestionCQC']) {
      this.planning['partenaire'] = detail.chauffeurPrestataire;
      // console.log(this.planning['partenaire']);
    }
    this.planning['program'] = false;
    // if (detail.materielLoue) {
    //   if (detail.materielLoue.program) {
    //     this.planning['program'] = true;
    //   }
    //   this.mouvBenneProgramme = detail.materielLoue.program || {};
    //   this.mvtProgramme();
    // }
    this.planning['id'] = 0;
    this.planning['client'] = detail.client || { id: 0 };
    if (detail.bon && detail.bon.clientDemandeur && detail.bon.clientDemandeur.id) {
      this.planning['clientDemandeur'] = detail.bon.clientDemandeur
      this.planning['clientDemandeur'].libelleObjetEntite = detail.bon.clientDemandeur.libelleObjetEntite || '';
    }
    this.planning['chantier'] = detail.chantier || { id: 0 };
    detail.camion = detail.camion || { id: 0 };

    if (detail.listMateriel && detail.listMateriel.length) {
      detail['listMateriel'].forEach(camion => {
        camion.libelleEdit = `${camion.numParc ? camion.numParc + ' / ' : ''}${camion.immatriculation || ''}`;
      });
      this.planning['listMateriel'] = detail['listMateriel'];
      this.listMateriel = this.planning['listMateriel'];
    } else if (detail.camion && detail.camion.id) {
      detail.camion.libelleEdit = `${detail.camion.numParc ?
        detail.camion.numParc + ' / ' : ''}${detail.camion.immatriculation || ''}`;
      this.planning['machine'] = Object.assign({}, detail.camion);
    }
    if (detail.article && detail.article.id > 0) {
      this.planning['prestation'] = detail.article;
      this.planning['qtePrevisionnelle'] = detail.article.qtePrevisionnelle;
      this.planning['qtePrevisionnelleShow'] = true;
      this.planning['prestation'].libelleObjetEntite = `${this.planning['prestation'].code ? this.planning['prestation'].code + ' / ' : ''} ${this.planning['prestation'].libelle || ''}`;
    } else {
      detail.listPrestation = detail.listPrestation || [];
      if (detail.listPrestation && detail.listPrestation.length) {
        this.planning['listPrestation'] = detail.listPrestation;
        this.planning['listPrestation'].forEach(prest => {
          prest.libelleObjetEntite = `${prest.code ? prest.code + ' / ' : ''} ${prest.libelle || ''}`;
        })
      }
    }

    this.planning['dateStart'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));
    this.planning['dateEnd'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));


    this.planning['hourStart'] = detail.heureDebut.slice(0, -6);
    this.planning['minStart'] = detail.heureDebut.slice(3).slice(0, -3);
    this.planning['hourEnd'] = detail.heureFin.slice(0, -6);
    this.planning['minEnd'] = detail.heureFin.slice(3).slice(0, -3);
    this.planning['multiPrestation'] = detail.listPrestation ? true : false;

    if (detail.rappelActif) {
      this.planning['rappel'] = detail.rappelLibre ? this.rappel[0] : this.rappel[0];
      this.planning['israppelLibre'] = detail.rappelLibre ? true : false;
      this.planning['rappelLibreValeur'] = detail.rappelLibre ?
        detail.valeurRappelLibre : '0';
    }

    this.step = 7;
    this.selectedChantier = this.planning['chantier'];

    if (this.planning['listPrestation']) {
      this.listpresta = this.planning['listPrestation'];
    }
    this.showEquipe = true;
    this.planning['showInfo'] = true;
    this.planning['date'] = this.planning['dateStart'];
    this.planning['modeEquipe'] = detail && detail.materielLoue ?
      detail.materielLoue.equipeDefinie || false : false;

    this.planning['isAcompte'] = this.eventSelected && detail && detail.facturation ? true : false;
    this.planning['acompte'] = parseFloat(this.eventSelected && detail && detail.facturation ? detail.facturation || 0 : 0).toFixed(2);

    let numContrat = this.eventSelected && detail && detail.contrat ? (detail.contrat.numContrat || '') : '';
    numContrat = numContrat !== '' ? numContrat : detail.numContrat || '';
    this.planning['isContrat'] = numContrat !== '' ? true : false;
    this.planning['numContrat'] = numContrat;
    this.planning['facturation'] = true;


    this.planning['exutoire'] = detail.exutoire || { id: 0 };
    this.planning['exutoire'].libelleObjetEntite = this.planning['exutoire'].nom || this.planning['exutoire'].libelleObjetEntite || '';
    if (this.planning['chantier'] && this.planning['chantier'].id) {
      this.getDetailChantier(this.planning['chantier']['id']).then(datas => {
        this.selectedChantier = datas.data && datas.data.length ? datas.data[0] : this.planning['chantier'];
        this.planning['chantier'] = datas.data && datas.data.length ? datas.data[0] : this.planning['chantier'];
        detail.chantier = datas.data && datas.data.length ? datas.data[0] : this.planning['chantier'];
        this.objEquipe['listLieu'] = this.selectedChantier['listLieu'] || [];
        this.planning['adresse'] = true;
        $('#slide-right').trigger('click');
      });
    }
    const site = detail && detail.site ?
      detail.site.id : this.common.user[2];
    const siteCA = detail && detail.siteCA ?
      detail.siteCA.id : this.common.user[2];

    this.listeSite.forEach(elt => {
      if (elt.id === site) {
        this.defaultSite = elt;
        this.planning['sitePrest'] = elt;
      }
      if (elt.id === siteCA) {
        this.defaultSiteCA = elt;
        this.planning['siteCA'] = elt;
      }
    });
    this.planning['showsite'] = true;
    this.planning['prereseigner'] = true;
    const planning = this.planning;
    this.modifier = false;
    this.getlistIndispo().then(dt => {
      planning['chauffeur'] = !this.isChauffeurIndispo(detail['chauffeur']) ? detail['chauffeur'] : { id: 0, libelleObjetEntite: 'A définir' };;
      const element = planning['chauffeur']
      this.selectedEvent = {
        start: this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY')),
        resource: {
          id: 'Aucun',
          title: 'Aucun',
          colorRes: `#fff`,
          eventColors: `#fff`
        }
      }
      if (element && element.id) {
        this.selectedEvent['resource'] = {
          id: element.id, title: `${element.nom || ''}  ${element.prenom || ''}`,
          colorRes: `#${element.couleur}`,
          eventColors: this.common.LightenDarkenColor(`#${element.couleur}`, -50),
          listeAssociationMissionInterim: element.listeAssociationMissionInterim || [],
          detail: element
        }
      }

      this.equipes.push(this.planning['chauffeur']);


      const data = Object.assign({}, detail);
      data['listePersonnelParPoste'] = data['listePersonnelParPoste'] || [];
      ctrl.objEquipe['listePersonnelParPoste'] = [];
      const poctuelPost = [];
      data['listePersonnelParPoste'].forEach(e => {
        const elt = Object.assign({}, e);
        elt.chauffeur = { id: 0, libelleObjetEntite: 'A définir' };
        elt['lieuChantier'] = elt['chauffeur'] ?
          elt['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
        elt['lieuDepart'] = elt['chauffeur'] ?
          elt['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
        poctuelPost.push(elt);
      });


      ctrl.objEquipe['site'] = planning['site'];
      ctrl.objEquipe['modeEquipe'] = planning['equipeDefinie'] || false;
      ctrl.objEquipe['mouvement'] = Object.assign({}, planning || { id: 0 });
      ctrl.objEquipe['chantier'] = Object.assign({}, ctrl.planning['chantier']);
      ctrl.objEquipe['chauffeur'] = Object.assign({}, planning['chauffeur']);
      ctrl.objEquipe['chauffeur'].libelleObjetEntite = ctrl.objEquipe['chauffeur'] && ctrl.objEquipe['chauffeur'].id ?
        `${ctrl.objEquipe['chauffeur'].matricule || ''} ${ctrl.objEquipe['chauffeur'].nom ||
        ''} ${ctrl.objEquipe['chauffeur'].prenom || ''}` : '';
      ctrl.objEquipe['lieuChantier'] = ctrl.objEquipe['chauffeur'] ?
        ctrl.objEquipe['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
      ctrl.objEquipe['lieuDepart'] = ctrl.objEquipe['chauffeur'] ?
        ctrl.objEquipe['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
      const benne = data['materielLoue'] || {};
      if (benne) {
        ctrl.objEquipe['modeEquipe'] = benne.equipeDefinie || false;
        ctrl.objEquipe['program'] = benne.clefProgram && (benne.clefProgram !== '' || benne.clefProgram !== '0') ? true : false;
        ctrl.objEquipe['qualificationLeader'] = benne.qualificationLeader;
        ctrl.objEquipe['leaderEquipe'] = benne.leaderEquipe || { id: 0 };
        if (ctrl.objEquipe['leaderEquipe'].id) {
          ctrl.objEquipe['leaderEquipe'] = ctrl.objEquipe['leaderEquipe'];
        }
        ctrl.objEquipe['leaderEquipe']['libelleObjetEntite'] = ctrl.objEquipe['leaderEquipe'] && ctrl.objEquipe['leaderEquipe'].id ?
          `${ctrl.objEquipe['leaderEquipe']['matricule']
          || ''} ${ctrl.objEquipe['leaderEquipe']['nom']
          || ''} ${ctrl.objEquipe['leaderEquipe']['prenom'] || ''}` : '';
        ctrl.objEquipe['lieuChantierParDefaut'] = ctrl.objEquipe['leaderEquipe'] ?
          ctrl.objEquipe['leaderEquipe'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
        ctrl.objEquipe['lieuDepartParDefaut'] = ctrl.objEquipe['leaderEquipe'] ?
          ctrl.objEquipe['leaderEquipe'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
        // if (ctrl.objEquipe['program']) {
        benne.listePersonnelParPoste = benne.listePersonnelParPoste || [];

        const posteMax = benne.listePersonnelParPoste.length > poctuelPost.length ? benne.listePersonnelParPoste.length : poctuelPost.length;

        for (let i = 0; i < posteMax; i++) {
          const objpost = poctuelPost[i] ? Object.assign({}, poctuelPost[i]) : { id: 0 };
          const elt = benne.listePersonnelParPoste[i] ? Object.assign({}, benne.listePersonnelParPoste[i]) : { id: 0 };
          elt.chauffeur = { id: 0, libelleObjetEntite: 'A définir' };
          objpost['id'] = ((i + 1) * -1),
            objpost['poste'] = objpost['poste'] || elt.poste;
          objpost['poste'].id = ((i + 1) * -1);
          objpost['personnelDefaut'] = elt.chauffeur;
          objpost['lieuChantierParDefaut'] = elt['chauffeur'] ?
            elt['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
          objpost['lieuDepartParDefaut'] = elt['chauffeur'] ?
            elt['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
          ctrl.objEquipe['listePersonnelParPoste'].push(objpost);
          this.equipes.push(objpost['chauffeur']);
        }
      }
    })

    // console.log( this.equipes)

  }

  // Afficher le msg de retour sygetrack et un bouton fermer
  setMsgSygetrack(msgSygetrack) {
    this.msgSygetrack = msgSygetrack;
    $('#container-msg-sygetrack').trigger('click');
  }

  // Fermer fenetre sygetrack
  closeSygetrack() {
    this.msgSygetrack = '';
    const ctrl = this;
    setTimeout(() => {
      this.common.closeModal();
    }, 300);
  }

  formatedHeureDebut() {
    const heurestart = this.planning['hourStart'] ? this.planning['hourStart'] :
      this.eventSelected['detail'].heureDebut.slice(0, -6);
    const minstart = this.planning['minStart'] ? this.planning['minStart'] : '00';
    return heurestart + ':' + minstart + ':00';
  }

  formatedHeureFin() {
    const heurefin = this.planning['hourEnd'] ? this.planning['hourEnd'] :
      this.eventSelected['detail'].heureFin.slice(0, -6);
    const minfin = this.planning['minEnd'] ? this.planning['minEnd'] : '00';
    return heurefin + ':' + minfin + ':00';
  }

  showChampIvalid() {
    this.editEvent(this.eventSelected, 5, 'times');
  }

  validerBSDDManContenantVert() {
    if (this.isDIS && !this.planning['multiPrestation'] && this.planning.numBSDD && this.planning.numBSDD !== '') {
      const numerosaisi = this.planning.numBSDD || '';
      const idArticle = this.planning && this.planning['prestation'] && this.planning['prestation'].id ?
        this.planning['prestation'].id || 0 : 0;
      const param = {
        'servlet': 'DBGestionAngular',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 28
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2] || 0
          },
          'NUM_BSDD_MANUEL': numerosaisi,
          'CLEF_ARTICLE': {
            'typeParam': 'int',
            'valeur': idArticle
          }
        }
      };
      if (idArticle) {
        return this.common.post('', { param: param }, true)
      } else {
        Promise.resolve({ data: true });
      }
    } else {
      return Promise.resolve({ data: true });
    }
  }

  getTextAffichageMachine() {
    let texte = '-';
    if (this.isEdit) {
      if (this.eventSelected.detail && this.eventSelected.detail.camion && this.eventSelected.detail.camion.id) {
        texte = this.eventSelected.detail.camion.libelleEdit || this.getTextImmatPlusNumParc(this.eventSelected.detail.camion);
      } else if (this.eventSelected.detail.listMateriel && this.eventSelected.detail.listMateriel.length) {
        texte = this.getTextImmatPlusNumParcMultiCamion(this.eventSelected.detail.listMateriel);
      }
    } else {
      if (this.planning && this.planning.machine && this.planning.machine.id) {
        texte = this.planning.machine.libelleObjetEntite || '';
      } else if (this.planning && this.planning.listMateriel && this.planning.listMateriel.length) {
        texte = this.getTextImmatPlusNumParcMultiCamion(this.planning.listMateriel);
      }
    }

    return texte;
  }

  getTextImmatPlusNumParc(obj) {
    let texte = (obj['numParc'] ? obj['numParc'] + ' / ' : '') + (obj['immatriculation'] || '');

    if (!texte && obj['libelleObjetEntite']) {
      texte = obj['libelleObjetEntite'];
    }

    if (!texte && obj['libelle']) {
      texte = obj['libelle'];
    }

    return texte;
  }

  getTextImmatPlusNumParcMultiCamion(liste) {
    let texte = '';
    liste.forEach(obj => {
      texte += '<div>' + this.getTextImmatPlusNumParc(obj) + '</div>';
    });

    return texte;
  }
}
